(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["callout-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.customElements && customElements.get('callout-shoppable')) return;

    class CalloutShoppable extends HTMLElement {
      connectedCallback() {
        if (this.__init) return;
        this.__init = true;

        this.markers = Array.prototype.slice.call(this.querySelectorAll('[data-callout-hotspot]'));
        this.overlays = Array.prototype.slice.call(this.querySelectorAll('[data-callout-panel]'));

        this.markers.forEach(function (marker) {
          marker.addEventListener('click', this.onMarkerClick.bind(this));
        }, this);

        this.setupPulseSync();

        this.onDocClick = this.onDocClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        document.addEventListener('click', this.onDocClick);
        document.addEventListener('keydown', this.onKeydown);

        this.addEventListener('shopify:block:select', function (e) {
          var marker = e.target && e.target.closest ? e.target.closest('[data-callout-hotspot]') : null;
          if (marker) this.open(marker.getAttribute('data-callout-hotspot'));
        }.bind(this));
      }

      // Hovering / focusing / opening a marker settles its pulse (and wave) via
      // `animation: none`, which restarts them from time 0 when released and
      // drifts out of step with the other markers. After the engaged state ends
      // we snap the freshly re-created animations back onto the markers' shared
      // start time so they line up again. (Requires the Web Animations API.)
      setupPulseSync() {
        var self = this;
        this.pulseMarkers = [];
        this.markers.forEach(function (marker) {
          if (!marker.getAnimations) return;
          self.pulseMarkers.push(marker);
          var resync = function () {
            requestAnimationFrame(function () { self.syncMarker(marker); });
          };
          marker.addEventListener('mouseleave', resync);
          marker.addEventListener('blur', resync, true);
        });
      }

      // The marker's dot pulse plus its wave pseudo-element, when present.
      markerAnimations(marker) {
        try { return marker.getAnimations({ subtree: true }); }
        catch (e) { return marker.getAnimations(); }
      }

      pulseOrigin() {
        if (this._pulseOrigin != null) return this._pulseOrigin;
        for (var i = 0; i < this.pulseMarkers.length; i++) {
          var anims = this.markerAnimations(this.pulseMarkers[i]);
          for (var j = 0; j < anims.length; j++) {
            if (anims[j].startTime != null) { this._pulseOrigin = anims[j].startTime; return this._pulseOrigin; }
          }
        }
        return this._pulseOrigin;
      }

      syncMarker(marker) {
        var origin = this.pulseOrigin();
        if (origin == null) return;
        this.markerAnimations(marker).forEach(function (a) {
          try { a.startTime = origin; } catch (e) {}
        });
      }

      syncAllMarkers() {
        var self = this;
        if (!this.pulseMarkers) return;
        requestAnimationFrame(function () {
          self.pulseMarkers.forEach(function (m) { self.syncMarker(m); });
        });
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocClick);
        document.removeEventListener('keydown', this.onKeydown);
      }

      overlayFor(id) {
        for (var i = 0; i < this.overlays.length; i++) {
          if (this.overlays[i].getAttribute('data-callout-panel') === id) return this.overlays[i];
        }
        return null;
      }

      open(id) {
        this.markers.forEach(function (m) {
          m.setAttribute('aria-expanded', m.getAttribute('data-callout-hotspot') === id ? 'true' : 'false');
        });
        this.overlays.forEach(function (o) {
          o.classList.toggle('is-open', o.getAttribute('data-callout-panel') === id);
        });
      }

      close() {
        this.markers.forEach(function (m) { m.setAttribute('aria-expanded', 'false'); });
        this.overlays.forEach(function (o) { o.classList.remove('is-open'); });
        this.syncAllMarkers();
      }

      onMarkerClick(e) {
        var marker = e.currentTarget;
        var id = marker.getAttribute('data-callout-hotspot');
        if (!this.overlayFor(id)) return;
        if (marker.getAttribute('aria-expanded') === 'true') {
          this.close();
        } else {
          this.open(id);
        }
      }

      onDocClick(e) {
        var marker = e.target.closest ? e.target.closest('[data-callout-hotspot]') : null;
        if (marker && this.contains(marker)) return;
        var panel = e.target.closest ? e.target.closest('[data-callout-panel]') : null;
        if (panel && this.contains(panel)) return;
        this.close();
      }

      onKeydown(e) {
        if (e.key === 'Escape' || e.key === 'Esc') this.close();
      }
    }

    if (window.customElements && !customElements.get('callout-shoppable')) {
      customElements.define('callout-shoppable', CalloutShoppable);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-eta-data"] && !Shopify.designMode) return;
  try {
    (function () {
    // Last value this page POSTed, so repeated syncs after a drawer refresh
    // that changed nothing relevant stay silent.
    var posted = null;

    function sync() {
      var el = document.querySelector('[data-cart-eta-data]');
      if (!el) return;

      var payload;
      try {
        payload = JSON.parse(el.textContent || '{}');
      } catch (e) {
        return;
      }

      // Round-tripping through the parser normalises the whitespace Liquid
      // leaves behind, so a value we wrote compares equal on the next render.
      // Key ORDER survives: variant ids are past 2^32-1, so they are not array
      // index keys and the object keeps insertion order - cart line order here,
      // which is what the legacy DOM order was too (it matched the line order on
      // 61 of 76 multi-line orders sampled; legacy's own order moved about, so
      // nothing downstream can be relying on it).
      var next = JSON.stringify(payload.map || {});
      var current = payload.current || '';

      // Nothing to say and nothing to correct: do not create a cart for a
      // visitor who has not added anything.
      if (next === '{}' && current === '') return;

      if (next === posted || next === current) {
        posted = next;
        return;
      }

      posted = next;

      var body = new FormData();
      body.append('attributes[eta_data]', next);

      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart/update.js', { method: 'POST', body: body }).catch(function () {});
    }

    window.esEtaData = { sync: sync };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', sync);
    } else {
      sync();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-eta-info"] && !Shopify.designMode) return;
  try {
    /* Delegated from the document rather than bound to the button: the drawer
     re-renders its body from the server after every cart change, which replaces
     the trigger element - a direct listener would be lost on the first update. */
  (function () {
    if (window.__esCartEtaInfo) return;
    window.__esCartEtaInfo = true;

    function dialog() {
      return document.querySelector('[data-cart-eta-info-dialog]');
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-cart-eta-info]');
      if (trigger) {
        var d = dialog();
        if (!d) return;
        event.preventDefault();
        /* showModal throws if it is already open (e.g. a double click). */
        if (!d.open) d.showModal();
        return;
      }
      if (event.target.closest('[data-cart-eta-info-close]')) {
        var open = dialog();
        if (open && open.open) open.close();
      }
    });

    /* Click the backdrop to dismiss: with showModal the dialog element itself
       fills the viewport, so a click landing ON it (not on the panel) is a
       backdrop click. */
    document.addEventListener('click', function (event) {
      var d = dialog();
      if (!d || !d.open || event.target !== d) return;
      d.close();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-promo-progress"] && !Shopify.designMode) return;
  try {
    // Multibuy progress bar controller. Fetches the active promo rules from the
  // ESR API worker (5-minute sessionStorage cache), reads the cart lines'
  // data attributes, and renders "Add N more" progress for the most recently
  // added eligible-but-unmet offer. Re-runs on cart:updated, quantity input
  // changes, and cart drawer body re-renders (MutationObserver).
  (function () {
    var TTL = 5 * 60 * 1000;
    var CACHE_KEY = 'esr:promo-rules';
    var rulesPromise = null;

    function getRules(endpoint, country) {
      if (rulesPromise) return rulesPromise;
      try {
        var cached = JSON.parse(sessionStorage.getItem(CACHE_KEY));
        if (cached && cached.endpoint === endpoint && Date.now() - cached.ts < TTL) {
          rulesPromise = Promise.resolve(cached.rules || []);
          return rulesPromise;
        }
      } catch (e) { /* ignore bad cache */ }
      var url = endpoint.replace(/\/+$/, '') + '/promotions';
      if (country) url += '?country=' + encodeURIComponent(country);
      rulesPromise = fetch(url)
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          var rules = data && data.rules ? data.rules : [];
          try {
            sessionStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), endpoint: endpoint, rules: rules }));
          } catch (e) { /* storage full/blocked - just skip caching */ }
          return rules;
        })
        .catch(function () { return []; });
      return rulesPromise;
    }

    function readLines(scope) {
      var lines = [];
      scope.querySelectorAll('[data-cart-line]').forEach(function (el) {
        var qtyInput = el.querySelector('[data-quantity-input]');
        var qty = qtyInput ? parseInt(qtyInput.value, 10) : parseInt(el.getAttribute('data-line-qty'), 10);
        lines.push({
          qty: qty > 0 ? qty : 0,
          tags: (el.getAttribute('data-line-tags') || '').split('||').filter(Boolean),
          type: el.getAttribute('data-line-type') || '',
          onSale: el.getAttribute('data-line-on-sale') === 'true'
        });
      });
      return lines;
    }

    function hasAny(list, tags) {
      for (var i = 0; i < list.length; i++) {
        if (tags.indexOf(list[i]) !== -1) return true;
      }
      return false;
    }

    // Mirrors the discount Function's qualification scope. Only tag-scoped
    // tiers are promptable - an unscoped tier would match the whole cart.
    function tierMatchesLine(tier, line) {
      var included = tier.includedTags || [];
      if (!included.length) return false;
      if (!hasAny(included, line.tags)) return false;
      if (hasAny(tier.excludedTags || [], line.tags)) return false;
      var inTypes = tier.includedTypes || [];
      if (inTypes.length && inTypes.indexOf(line.type) === -1) return false;
      if ((tier.excludedTypes || []).indexOf(line.type) !== -1) return false;
      if (tier.allowSaleItem === false && line.onSale) return false;
      return true;
    }

    function formatSaving(tier) {
      if (tier.discountType === 'percent') return tier.discountAmount + '%';
      return '$' + tier.discountAmount;
    }

    /* Does tier 'a' pay better than tier 'b'? Types that cannot be compared
       (a percentage against a fixed amount) are treated as an improvement -
       better to ask than to silently drop a genuine offer. */
    function outranks(a, b) {
      if (!b) return true;
      if (a.discountType !== b.discountType) return true;
      return Number(a.discountAmount) > Number(b.discountAmount);
    }

    // Total qualifying units in the cart for this tier. Which line they came
    // from no longer matters - the prompt asks for items, not a product.
    function countFor(tier, lines) {
      var count = 0;
      lines.forEach(function (line) {
        if (line.qty > 0 && tierMatchesLine(tier, line)) count += line.qty;
      });
      return count;
    }

    function compute(mount, rules) {
      var scope = mount.closest('dialog.drawer') || mount.closest('.shopify-section') || document;
      var lines = readLines(scope);
      // Best = the unmet multibuy tier the cart is closest to earning.
      var best = null;
      rules.forEach(function (rule) {
        if (rule.type !== 'tiered') return;
        var tiers = (rule.tiers || []).filter(Boolean);
        if (!tiers.length) return;

        /* What the cart has ALREADY earned on this rule. Without this the bar
           prompts towards any unmet tier, however worthless: the promos coming
           out of the app repeat the same discount at every step (2+, 3+ and 4+
           all at 20%), so at quantity 2 the 2+ tier was met, the bar moved to
           the 3+ tier, and it read "Add 1 more ... to save 20%" to a shopper who
           already had 20%. It also looked frozen, because the wording is the
           same at every step (#19524265 testing).

           Every tier is measured, not just the promptable ones, so a met 1+ tier
           still counts as earned. */
        var earned = null;
        tiers.forEach(function (tier) {
          var count = countFor(tier, lines);
          if (count > 0 && count >= tier.quantity && outranks(tier, earned)) { earned = tier; }
        });

        tiers.forEach(function (tier) {
          // Only tag-scoped multibuy tiers are promptable - an unscoped tier
          // would match the whole cart.
          if (!(tier.quantity >= 2)) return;
          var count = countFor(tier, lines);
          if (!(count > 0 && count < tier.quantity)) return;
          // Nothing to gain, so nothing to ask for.
          if (!outranks(tier, earned)) return;
          /* Fewest items still needed wins, so the shopper is always shown the
             offer within easiest reach; where two are equally close, the one
             that pays better. */
          var remaining = tier.quantity - count;
          if (best === null ||
              remaining < best.remaining ||
              (remaining === best.remaining && outranks(tier, best.tier))) {
            best = { tier: tier, count: count, remaining: remaining };
          }
        });
      });
      render(mount, best);
    }

    function render(mount, best) {
      if (!best) {
        mount.hidden = true;
        return;
      }
      var textEl = mount.querySelector('[data-promo-progress-text]');
      var barEl = mount.querySelector('[data-promo-progress-bar]');
      if (!textEl || !barEl) return;
      var template = mount.getAttribute('data-promo-message') || 'Add $count more $items to your cart to save $saving';
      // Any product carrying the rule's tag counts, so the prompt asks for
      // items rather than naming one. $product is the previous placeholder and
      // resolves to the same word, so a message already saved in a store's
      // settings reads correctly without being re-edited.
      var noun = best.remaining === 1 ? 'item' : 'items';
      textEl.textContent = template
        .replace('$count', best.remaining)
        .replace('$items', noun)
        .replace('$product', noun)
        .replace('$saving', formatSaving(best.tier))
        .replace('$message', best.tier.discountMessage || '');
      var pct = Math.round((best.count / best.tier.quantity) * 100);
      barEl.style.width = Math.max(4, Math.min(100, pct)) + '%';
      mount.hidden = false;
    }

    function runAll() {
      var mounts = document.querySelectorAll('[data-promo-progress]');
      if (!mounts.length) return;
      var endpoint = mounts[0].getAttribute('data-promo-endpoint');
      if (!endpoint) return;
      getRules(endpoint, mounts[0].getAttribute('data-promo-country') || '').then(function (rules) {
        document.querySelectorAll('[data-promo-progress]').forEach(function (mount) {
          compute(mount, rules);
        });
      });
    }

    // Debounced with a timer, NOT requestAnimationFrame - rAF never fires in
    // a hidden/background tab, which would freeze the bar until the next
    // focus + event.
    var scheduled = null;
    function schedule() {
      if (scheduled) return;
      scheduled = setTimeout(function () {
        scheduled = null;
        runAll();
      }, 80);
    }

    document.addEventListener('cart:updated', schedule);
    document.addEventListener('change', function (e) {
      if (e.target.closest('[data-quantity-input]')) schedule();
    });

    // The cart drawer re-renders its body via innerHTML after every change,
    // replacing its mount - recompute when that happens (also keeps the cart
    // page's bar in sync with drawer-driven changes). Mutations inside a
    // mount are our own renders; ignore those to avoid loops.
    var drawerEl = document.getElementById('cart-drawer');
    if (drawerEl && window.MutationObserver) {
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var target = mutations[i].target;
          if (!target.closest || !target.closest('[data-promo-progress]')) {
            schedule();
            return;
          }
        }
      }).observe(drawerEl, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runAll);
    } else {
      runAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-remove-confirm"] && !Shopify.designMode) return;
  try {
    /* One dialog per page. The cart page and the drawer both render this snippet,
     and on the cart page both are present at once, so the second registration is
     dropped rather than overwriting the first. */
  (function () {
    if (window.esCartConfirm) return;

    function dialogEl() {
      return document.querySelector('[data-cart-remove-confirm]');
    }

    window.esCartConfirm = function () {
      var dialog = dialogEl();
      /* No dialog, or a browser without showModal: proceed rather than trap the
         shopper with a remove button that does nothing. */
      if (!dialog || typeof dialog.showModal !== 'function') return Promise.resolve(true);

      return new Promise(function (resolve) {
        var settled = false;
        function settle(ok) {
          if (settled) return;
          settled = true;
          dialog.removeEventListener('close', onClose);
          dialog.removeEventListener('click', onClick);
          if (dialog.open) dialog.close();
          resolve(ok);
        }
        /* Escape and the backdrop both arrive as a native close, which is a
           decline - only the confirm button resolves true. */
        function onClose() { settle(false); }
        function onClick(event) {
          if (event.target.closest('[data-rc-confirm]')) { settle(true); return; }
          if (event.target.closest('[data-rc-cancel]')) { settle(false); return; }
          /* A click on the dialog element itself is the backdrop: the panel
             inside it swallows clicks on the panel. */
          if (event.target === dialog) settle(false);
        }
        dialog.addEventListener('close', onClose);
        dialog.addEventListener('click', onClick);
        dialog.showModal();
      });
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["category-card"] && !Shopify.designMode) return;
  try {
    // Belt-and-suspenders autoplay: browsers only autoplay muted, inline video,
  // and the markup's autoplay attribute alone is unreliable. Force muted +
  // playsinline and kick off play() (ignoring the promise rejection when a
  // browser still blocks it). One guarded, delegated controller for all tiles.
  (function () {
    if (window.__esCategoryCardVideo) return;
    window.__esCategoryCardVideo = true;

    function start(video) {
      video.muted = true;
      video.setAttribute('muted', '');
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      var played = video.play();
      if (played && typeof played.catch === 'function') played.catch(function () {});
    }

    function init(root) {
      (root || document).querySelectorAll('.category-card__media video').forEach(start);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }

    // Re-init when a section is re-rendered in the theme editor.
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["checkbox"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.checkbox__input[data-indeterminate]').forEach(function (input) {
    input.indeterminate = true;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-card-meta"] && !Shopify.designMode) return;
  try {
    // Fills in the "From" price on collection cards. See the doc header for why
  // this is hydrated rather than rendered: Liquid cannot see past a
  // collection's first 50 products, so it cannot produce a true minimum.
  //
  // ONE request serves the whole page - every card's handle is aliased into a
  // single Storefront query. Nothing here runs unless the theme setting emitted
  // the data attributes, so with the toggle off this costs zero requests.
  (function () {
    if (window.__ccmInit) return;
    window.__ccmInit = true;

    var SEP = ' \u00B7 '; // middle dot per the design, written as an escape so
    // this file stays pure ASCII - one multibyte character truncates the whole
    // compiled snippet-scripts.js bundle.

    // The braces of the shop's money format are built from char codes rather
    // than written out: a literal Liquid-looking token inside a javascript tag
    // is flagged by Theme Check, and Liquid is not rendered in here anyway.
    var OPEN = String.fromCharCode(123, 123);
    var CLOSE = String.fromCharCode(125, 125);

    function money(amount, format) {
      var cents = Math.round(amount * 100);
      var whole = Math.floor(cents / 100);
      var rem = cents % 100;
      var out = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      // Trailing zeros are dropped, matching money_without_trailing_zeros and
      // the design's "From $199". A price with real cents keeps them.
      if (rem > 0) out = out + '.' + (rem < 10 ? '0' + rem : String(rem));
      var start = format.indexOf(OPEN);
      var end = format.indexOf(CLOSE);
      if (start < 0 || end < start) return out;
      return format.slice(0, start) + out + format.slice(end + 2);
    }

    function fill(el, amount, format, template) {
      var span = el.querySelector('[data-ccm-price]');
      if (!span) return;
      var sep = document.createElement('span');
      sep.className = 'collection-card-meta__sep';
      sep.setAttribute('aria-hidden', 'true');
      sep.textContent = SEP;
      span.textContent = '';
      span.appendChild(sep);
      span.appendChild(document.createTextNode(template.split('__CCM_PRICE__').join(money(amount, format))));
    }

    function run() {
      var nodes = document.querySelectorAll('[data-ccm-handle]:not([data-ccm-done])');
      if (!nodes.length) return;

      var first = nodes[0];
      var endpoint = first.getAttribute('data-ccm-endpoint');
      var token = first.getAttribute('data-ccm-token');
      if (!endpoint || !token) return;
      var format = first.getAttribute('data-ccm-money');
      var template = first.getAttribute('data-ccm-from');
      if (!format || !template) return;

      // Mark everything up front: a card is attempted once, whether or not the
      // request succeeds. Without this a failure would be retried on every
      // mutation for the life of the page.
      var byHandle = {};
      var handles = [];
      for (var i = 0; i < nodes.length; i++) {
        nodes[i].setAttribute('data-ccm-done', '');
        var h = nodes[i].getAttribute('data-ccm-handle');
        if (!h) continue;
        if (!byHandle[h]) { byHandle[h] = []; handles.push(h); }
        byHandle[h].push(nodes[i]);
      }
      if (!handles.length) return;

      var parts = [];
      for (var j = 0; j < handles.length; j++) {
        parts.push('c' + j + ': collection(handle: ' + JSON.stringify(handles[j]) +
          ') { products(first: 1, sortKey: PRICE) { nodes { priceRange { minVariantPrice { amount } } } } }');
      }
      request('{' + parts.join(' ') + '}', 1);

      function request(query, attempt) {
        fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': token },
          body: JSON.stringify({ query: query })
        }).then(function (response) {
          if (!response.ok) throw new Error('ccm');
          return response.json();
        }).then(function (payload) {
          var data = payload && payload.data;
          if (!data) return;
          for (var k = 0; k < handles.length; k++) {
            var entry = data['c' + k];
            if (!entry || !entry.products || !entry.products.nodes || !entry.products.nodes.length) continue;
            var amount = parseFloat(entry.products.nodes[0].priceRange.minVariantPrice.amount);
            // Floor rule: a zero minimum is a placeholder or gift card, so the
            // segment stays empty rather than reading "From $0".
            if (!(amount > 0)) continue;
            var els = byHandle[handles[k]];
            for (var m = 0; m < els.length; m++) fill(els[m], amount, format, template);
          }
        }).catch(function () {
          // Degrade to the count alone. One retry with backoff - the storefront
          // does return 429 under load - then stay quiet rather than storming it.
          if (attempt < 2) {
            setTimeout(function () { request(query, attempt + 1); }, 1500);
          }
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }

    // The collections grid appends cards on "load more", so pick those up too.
    // Debounced, and each card is only ever attempted once (data-ccm-done).
    var pending = null;
    var observer = new MutationObserver(function () {
      if (pending) clearTimeout(pending);
      pending = setTimeout(run, 200);
    });
    if (document.body) observer.observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-filters-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__esCollectionFilterAccordion) return;
    window.__esCollectionFilterAccordion = true;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function panelOf(btn) {
      var id = btn.getAttribute('aria-controls');
      return id ? document.getElementById(id) : null;
    }

    function expand(btn) {
      var panel = panelOf(btn);
      if (!panel) return;
      btn.setAttribute('aria-expanded', 'true');
      if (reduce) {
        panel.style.height = 'auto';
        return;
      }
      var target = panel.scrollHeight;
      panel.style.height = '0px';
      void panel.offsetHeight;
      panel.style.height = target + 'px';
      var onEnd = function (e) {
        if (e.propertyName !== 'height') return;
        panel.removeEventListener('transitionend', onEnd);
        // Release to auto so the panel reflows if its content changes.
        panel.style.height = 'auto';
      };
      panel.addEventListener('transitionend', onEnd);
    }

    function collapse(btn) {
      var panel = panelOf(btn);
      if (!panel) return;
      btn.setAttribute('aria-expanded', 'false');
      if (reduce) {
        panel.style.height = '0px';
        return;
      }
      // From auto -> a fixed px height, then to 0 so the transition has two
      // concrete endpoints to animate between.
      panel.style.height = panel.scrollHeight + 'px';
      void panel.offsetHeight;
      panel.style.height = '0px';
    }

    // Only one group open at a time: collapse any other expanded group.
    function closeOthers(groups, except) {
      var open = groups.querySelectorAll('.collection-filters__group-summary[aria-expanded="true"]');
      for (var i = 0; i < open.length; i++) {
        if (open[i] !== except) collapse(open[i]);
      }
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.collection-filters__group-summary') : null;
      if (!btn) return;
      // Scope single-open to the whole drawer so the Sort group (which sits
      // outside .collection-filters__groups, above On Sale) is part of the set.
      var groups = btn.closest('[data-collection-filters]');

      if (btn.getAttribute('aria-expanded') === 'true') {
        collapse(btn);
      } else {
        if (groups) closeOthers(groups, btn);
        expand(btn);
      }
    });
  })();

  /* Dual-thumb price range: keeps the two thumbs ordered, paints the active
     segment, and two-way-syncs with the Min/Max number fields. The actual
     filtering is wired by the vendor; this is just the control. */
  (function () {
    if (window.__esCollectionPriceRange) return;
    window.__esCollectionPriceRange = true;

    function digits(value) {
      return parseInt(String(value || '').replace(/[^0-9]/g, ''), 10);
    }

    function initRange(root) {
      var minInput = root.querySelector('[data-range-min]');
      var maxInput = root.querySelector('[data-range-max]');
      var fill = root.querySelector('[data-range-fill]');
      if (!minInput || !maxInput) return;

      var price = root.parentElement;
      var minField = price.querySelector('[data-price-min-field]');
      var maxField = price.querySelector('[data-price-max-field]');
      var lo = parseInt(minInput.min, 10);
      var hi = parseInt(minInput.max, 10);
      var span = hi - lo || 1;

      function money(n) {
        return '$' + n;
      }

      function paint() {
        var a = parseInt(minInput.value, 10);
        var b = parseInt(maxInput.value, 10);
        if (fill) {
          fill.style.setProperty('--fill-start', ((a - lo) / span) * 100 + '%');
          fill.style.setProperty('--fill-end', ((b - lo) / span) * 100 + '%');
        }
      }

      function onMin() {
        if (parseInt(minInput.value, 10) > parseInt(maxInput.value, 10)) {
          minInput.value = maxInput.value;
        }
        if (minField) minField.value = money(minInput.value);
        paint();
      }

      function onMax() {
        if (parseInt(maxInput.value, 10) < parseInt(minInput.value, 10)) {
          maxInput.value = minInput.value;
        }
        if (maxField) maxField.value = money(maxInput.value);
        paint();
      }

      minInput.addEventListener('input', onMin);
      maxInput.addEventListener('input', onMax);

      // Typing in a field moves the matching thumb (clamped to the other one).
      if (minField) {
        minField.addEventListener('change', function () {
          var v = digits(minField.value);
          if (isNaN(v)) v = lo;
          v = Math.max(lo, Math.min(v, parseInt(maxInput.value, 10)));
          minInput.value = v;
          minField.value = money(v);
          paint();
        });
      }
      if (maxField) {
        maxField.addEventListener('change', function () {
          var v = digits(maxField.value);
          if (isNaN(v)) v = hi;
          v = Math.min(hi, Math.max(v, parseInt(minInput.value, 10)));
          maxInput.value = v;
          maxField.value = money(v);
          paint();
        });
      }

      paint();
    }

    function initAll() {
      var roots = document.querySelectorAll('[data-price-range]');
      for (var i = 0; i < roots.length; i++) {
        /* Guard per root so a re-init (injected controls) does not bind twice. */
        if (roots[i].__esRangeInit) continue;
        roots[i].__esRangeInit = true;
        initRange(roots[i]);
      }
    }

    /* Exposed so client-rendered price controls (Constructor facets) can be wired
       after injection - this module otherwise only runs once on load. */
    window.esCollectionPriceRange = { init: initAll };

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
  })();

  /* Mobile sort: the radios re-sort via Shopify's native ?sort_by (set on the
     current URL so other params are preserved). Sort needs no vendor wiring. */
  (function () {
    if (window.__esCollectionSortRadios) return;
    window.__esCollectionSortRadios = true;

    document.addEventListener('change', function (e) {
      var input = e.target;
      if (!input || input.name !== 'sort_by') return;
      if (!input.closest('[data-sort-options]')) return;
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', input.value);
      window.location.href = url.toString();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-sort"] && !Shopify.designMode) return;
  try {
    /* Constructor-driven sort for the collection sort control.

     The control is rendered by the collection-header section while the grid it sorts
     lives in the collection section, and sections cannot call into each other - so the
     two talk through events on document: "constructor:sort-options" in (the shared
     facet module announcing what Constructor offers and what is selected), and
     "constructor:sort" out. The grid owns the query; this is only a view of it.

     Until that first event arrives the control is left exactly as Liquid rendered it,
     which is what keeps the Shopify ?sort_by behaviour intact when Constructor is off. */
  (function () {
    if (window.__esCollectionSortCnstrc) return;
    window.__esCollectionSortCnstrc = true;

    function label(root, name) {
      var el = root.querySelector('[data-sort-label]');
      if (!el) return;
      var prefix = root.getAttribute('data-sort-prefix') || 'Sort by';
      el.textContent = name ? prefix + ': ' + name : prefix;
    }

    /* Each option is a real link to this page with the sort param set, matching what
       the URL becomes when it is chosen. Anchors, not buttons: the option styling is
       written for anchors, so a button arrives with native chrome the class never
       resets - and a real href means the control still works if the click handler
       never binds. The click is intercepted so the grid re-queries in place. */
    function href(paramName, paramValue) {
      var url = new URL(window.location.href);
      url.searchParams.set(paramName, paramValue);
      /* A new sort is a new result set, so the loaded depth no longer applies. */
      url.searchParams.delete('loaded');
      /* The two engines name the parameter differently - Constructor sorts on
         "sort", Shopify on "sort_by" - so a URL that arrived carrying the other
         one would keep a stale sort in the address after the engine switched.
         Only the one being set survives (#19669138). */
      if (paramName !== 'sort_by') url.searchParams.delete('sort_by');
      if (paramName !== 'sort') url.searchParams.delete('sort');
      return url.pathname + url.search;
    }

    function build(root, detail) {
      var list = root.querySelector('.collection-sort__options');
      if (!list) return;
      list.textContent = '';
      var selectedName = '';
      var paramName = detail.param || 'sort';

      detail.options.forEach(function (o) {
        if (o.active) selectedName = o.label;

        var li = document.createElement('li');
        var link = document.createElement('a');
        link.className = 'collection-sort__option' + (o.active ? ' collection-sort__option--active' : '');
        link.href = href(paramName, o.param);
        link.setAttribute('data-cnstrc-sort-choice', o.value);
        if (o.active) link.setAttribute('aria-current', 'true');
        link.textContent = o.label;
        li.appendChild(link);
        list.appendChild(li);
      });

      label(root, selectedName);
      root.setAttribute('data-cnstrc-sort-driven', 'true');
    }

    document.addEventListener('constructor:sort-options', function (e) {
      var detail = e.detail || {};
      if (!detail.options || !detail.options.length) return;
      document.querySelectorAll('[data-collection-sort]').forEach(function (root) {
        build(root, detail);
      });
    });

    document.addEventListener('click', function (e) {
      var choice = e.target.closest ? e.target.closest('[data-cnstrc-sort-choice]') : null;
      if (!choice) return;
      e.preventDefault();
      var root = choice.closest('[data-collection-sort]');
      /* Close the disclosure so the shopper sees the grid update, not the open list. */
      if (root) root.open = false;
      document.dispatchEvent(
        new CustomEvent('constructor:sort', { detail: { value: choice.getAttribute('data-cnstrc-sort-choice') } })
      );
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["constructor-facets"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.esrFacets) return;

    /* Facet values travel as repeated params (f.size=Round&f.size=Square) rather
       than one delimited value, so a value containing the delimiter cannot corrupt
       the rest. The price range is a single "min-max" value under the same prefix. */
    var PREFIX = 'f.';
    var SORT_PARAM = 'sort';

    /* Internally a sort is "sortBy|sortOrder", because Constructor needs both. In the
       URL it is written Shopify's way - price-descending - which is prettier than an
       encoded pipe and matches what shoppers already see on this site. Decoding splits
       on the LAST dash so a sort_by containing one still round-trips. */
    function encodeSort(value) {
      return value ? value.replace('|', '-') : '';
    }

    function decodeSort(param) {
      if (!param) return null;
      var i = param.lastIndexOf('-');
      if (i < 1) return null;
      return param.slice(0, i) + '|' + param.slice(i + 1);
    }

    window.esrFacets = {
      create: function (config) {
        var options = config || {};
        var onChange = options.onChange || function () {};
        var syncUrl = options.syncUrl === true;
        /* Search shows sort inside the drawer at every breakpoint. A collection page
           only does so on mobile, because its desktop sort lives in the collection
           header - so the group takes the existing mobile-only modifier there. */
        var sortGroupClass = options.sortDesktop === true
          ? 'collection-filters__group--sort-search'
          : 'collection-filters__group--sort';

        /* Facets the surface has asked to leave out of the drawer, from a
           merchant-entered comma-separated list of labels ("Pattern, Product
           Type, Colour/Finish"). Compared loosely - lower-cased with everything
           but letters and digits stripped - so "Product Type" hides the facet
           whether Constructor names it product_type or Product Type, and a
           trailing space or a slash in the setting cannot miss. Values already
           selected for a hidden facet (from a shared URL) still apply and still
           show as chips, so the shopper can clear them. */
        function facetKey(value) {
          return String(value == null ? '' : value).toLowerCase().replace(/[^a-z0-9]+/g, '');
        }
        var hiddenFacets = [];
        (Array.isArray(options.hiddenFacets)
          ? options.hiddenFacets
          : String(options.hiddenFacets || '').split(',')
        ).forEach(function (label) {
          var key = facetKey(label);
          if (key) hiddenFacets.push(key);
        });
        function isHiddenFacet(f) {
          if (!hiddenFacets.length || !f) return false;
          return hiddenFacets.indexOf(facetKey(f.name)) !== -1
            || hiddenFacets.indexOf(facetKey(f.display_name)) !== -1;
        }

        /* Selected values, keyed by facet name: multi-select facets hold an array of
           values, the price range holds a single "min-max" string. Constructor takes
           exactly that shape as its filters argument. */
        var selected = {};
        /* Constructor identifies a sort option by sort_by AND sort_order together
           (price appears twice, ascending and descending), so both are held and the
           radio value encodes the pair. Null means the engine's own default. */
        var sort = null;

        var facetsHost = document.querySelector('[data-cnstrc-facets]');
        var sortHost = document.querySelector('[data-cnstrc-sort]');
        var chipsHost = document.querySelector('[data-cnstrc-chips]');
        /* Translated label comes through a data attribute: Liquid is not rendered
           inside a javascript tag. */
        var SORT_LABEL = (sortHost && sortHost.getAttribute('data-sort-label')) || 'Sort by';

        function hasFilters() {
          return Object.keys(selected).some(function (k) {
            return selected[k] && selected[k].length;
          });
        }

        /* ---------- URL ---------- */

        function readUrl() {
          var params = new URL(window.location.href).searchParams;
          params.forEach(function (value, key) {
            if (key.indexOf(PREFIX) !== 0) return;
            var name = key.slice(PREFIX.length);
            if (!name) return;
            selected[name] = (selected[name] || []).concat([value]);
          });
          sort = decodeSort(params.get(SORT_PARAM));
        }

        function writeUrl() {
          if (!syncUrl) return;
          var url = new URL(window.location.href);
          /* Rebuild the facet params wholesale: deleting per key would leave stale
             values behind for a facet that has just been emptied. */
          /* Array.from, not slice.call: a URLSearchParams iterator has no length, so
             slice.call returns an empty array and the stale params survive - which left
             a cleared filter in the URL and duplicated values on repeated toggles. */
          Array.from(url.searchParams.keys()).forEach(function (key) {
            if (key.indexOf(PREFIX) === 0) url.searchParams.delete(key);
          });
          Object.keys(selected).forEach(function (name) {
            (selected[name] || []).forEach(function (value) {
              url.searchParams.append(PREFIX + name, value);
            });
          });
          if (sort) url.searchParams.set(SORT_PARAM, encodeSort(sort));
          else url.searchParams.delete(SORT_PARAM);
          window.history.replaceState(window.history.state, '', url.toString());
        }

        /* ---------- Rendering ---------- */

        /* Clones the Liquid-rendered template so injected controls carry the real
           design-system markup: the checkbox's hidden input plus its styled box, and
           the inline plus/minus icons. Building these as strings produced unstyled
           markup. */
        function tpl(name) {
          var t = document.querySelector('[data-cnstrc-tpl="' + name + '"]');
          return t ? t.content.firstElementChild.cloneNode(true) : null;
        }

        /* ---------- Colour swatches ----------
           Constructor's colour facet arrives as plain values ("Natural Timber"),
           and the swatches live in the colour_swatch metaobjects, published by
           the filter drawer as handle -> { c: hex, i: image url }.

           Matched on HANDLE, not label: product-level swatches are named after
           the colour they are, so several share a label (staging has six
           labelled "Green") and a label lookup cannot choose between them. The
           family entry is always the plain handleized name, product ones are
           prefixed. */
        function swatchHandle(value) {
          return String(value == null ? '' : value)
            .toLowerCase()
            .replace(/&/g, ' ')
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');
        }

        /* Mirrors the Liquid checkbox's rule: a hex brighter than 220 gets a grey
           ring so white and cream don't vanish against the drawer. Image swatches
           are always ringed - the artwork can be pale at its edges and we cannot
           measure it here. */
        function isLightSwatch(hex) {
          var h = String(hex || '').replace('#', '');
          if (h.length === 3) { h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2]; }
          if (h.length !== 6) { return false; }
          var r = parseInt(h.slice(0, 2), 16);
          var g = parseInt(h.slice(2, 4), 16);
          var b = parseInt(h.slice(4, 6), 16);
          if (isNaN(r) || isNaN(g) || isNaN(b)) { return false; }
          /* Shopify's color_brightness weighting, so JS and Liquid agree. */
          return ((r * 299 + g * 587 + b * 114) / 1000) > 220;
        }

        /* Turns a cloned option into a swatch checkbox. Returns false when there
           is nothing to show - no entry, or an entry with neither colour nor
           image - and the caller leaves the standard checkbox alone. */
        function applySwatch(option, value) {
          var map = window.esrColourSwatches;
          if (!map) { return false; }
          var sw = map[swatchHandle(value)];
          if (!sw || (!sw.c && !sw.i && !sw.g)) { return false; }
          option.classList.add('checkbox--colour');
          if (sw.c) { option.style.setProperty('--checkbox-colour', sw.c); }
          /* Gradient and image share --checkbox-swatch-image, which the
             stylesheet reads as background-image - a linear-gradient() is a
             background-image, so no second variable is needed. The image is set
             LAST on purpose: with both present the later set wins, which is the
             image > gradient > colour order the old theme documented. */
          if (sw.g) { option.style.setProperty('--checkbox-swatch-image', sw.g); }
          if (sw.i) { option.style.setProperty('--checkbox-swatch-image', 'url("' + sw.i + '")'); }
          /* A gradient is ringed like an image: it cannot be measured from one
             hex, and the two the client asked for both end in white, which would
             otherwise vanish into the drawer. */
          if (sw.i || sw.g || isLightSwatch(sw.c)) { option.classList.add('checkbox--colour-light'); }
          return true;
        }

        /* The footer's "View N results" was rendered by Liquid with the collection's
           full total (or no number at all on search) and never touched again, so it
           read 189 while the grid header said 28. The button carries the translated
           label as a template; fill in Constructor's total on every render, the way
           the grid header does. Only the label span is written, so the button's own
           markup and listeners are left alone. */
        function renderCount(total) {
          if (typeof total !== 'number') return;
          document.querySelectorAll('[data-cnstrc-view-results]').forEach(function (button) {
            var tpl = button.getAttribute('data-view-results-tpl');
            if (!tpl) return;
            var label = button.querySelector('.button__label') || button;
            label.textContent = tpl.replace('XCOUNTX', total);
          });
        }

        /* Which facet is the colour one. Matched on the name rather than hard
           coded, so a rename in Constructor does not silently drop the swatches;
           covers colour and color. */
        function isColourFacet(f) {
          return /colou?r/i.test((f && (f.display_name || f.name)) || '');
        }

        /* Groups the shopper has opened, so a re-render after filtering does not
           collapse the drawer under them. */
        function openFacets() {
          if (!facetsHost) return {};
          var open = {};
          facetsHost.querySelectorAll('[data-facet-group]').forEach(function (group) {
            var summary = group.querySelector('.collection-filters__group-summary');
            if (summary && summary.getAttribute('aria-expanded') === 'true') {
              open[group.getAttribute('data-facet-group')] = true;
            }
          });
          return open;
        }

        function renderSort(sortOptions) {
          if (!sortHost) return;
          var usable = (sortOptions || []).filter(function (o) { return !o.hidden; });
          if (!usable.length) {
            sortHost.textContent = '';
            return;
          }

          var wasOpen = !!sortHost.querySelector('[aria-expanded="true"]');
          var group = tpl('group');
          if (!group) return;
          var id = 'cf-cnstrc-sort';

          group.classList.add(sortGroupClass);
          group.querySelector('[data-tpl-label]').textContent = SORT_LABEL;
          var summary = group.querySelector('.collection-filters__group-summary');
          var panel = group.querySelector('.collection-filters__group-panel');
          summary.setAttribute('aria-controls', id);
          summary.setAttribute('aria-expanded', wasOpen ? 'true' : 'false');
          panel.id = id;
          panel.style.height = wasOpen ? 'auto' : '0';

          var body = group.querySelector('[data-tpl-body]');
          body.classList.add('collection-filters__group-body--sort');

          usable.forEach(function (o) {
            var option = tpl('sort-option');
            if (!option) return;
            var value = o.sort_by + '|' + o.sort_order;
            var oid = id + '-' + value.replace(/[^a-z0-9]+/gi, '-');
            var input = option.querySelector('.radio__input');
            option.setAttribute('for', oid);
            input.id = oid;
            input.value = value;
            /* Before a shopper chooses, the engine's own selected option is checked. */
            input.checked = sort ? sort === value : o.status === 'selected';
            input.setAttribute('data-cnstrc-sort-value', value);
            option.querySelector('.radio__label').textContent = o.display_name;
            body.appendChild(option);
          });

          sortHost.textContent = '';
          sortHost.appendChild(group);

          /* Anything outside the drawer that presents the same options - the desktop
             sort control on a collection page lives in a different section - rebuilds
             from this event rather than duplicating the render. */
          var chosen = currentSort(usable);
          document.dispatchEvent(
            new CustomEvent('constructor:sort-options', {
              detail: {
                selected: chosen,
                param: SORT_PARAM,
                options: usable.map(function (o) {
                  var value = o.sort_by + '|' + o.sort_order;
                  return {
                    value: value,
                    param: encodeSort(value),
                    label: o.display_name,
                    active: value === chosen
                  };
                })
              }
            })
          );
        }

        /* The engine's default counts as the selection until the shopper picks one. */
        function currentSort(usable) {
          if (sort) return sort;
          var chosen = (usable || []).filter(function (o) { return o.status === 'selected'; })[0];
          return chosen ? chosen.sort_by + '|' + chosen.sort_order : null;
        }

        function renderFacets(facets) {
          if (!facetsHost) return;
          var open = openFacets();
          facetsHost.textContent = '';

          (facets || []).forEach(function (f) {
            /* compare_at_price comes back as a list of individual prices rather than
               an is-discounted flag, so it cannot drive the designed On Sale toggle
               and is left out until Constructor exposes a boolean facet. */
            if (f.hidden || f.name === 'compare_at_price' || isHiddenFacet(f)) return;

            var group = tpl('group');
            if (!group) return;
            var id = 'cf-cnstrc-' + f.name;
            var isOpen = !!open[f.name];

            group.setAttribute('data-facet-group', f.name);
            group.querySelector('[data-tpl-label]').textContent = f.display_name || f.name;

            var summary = group.querySelector('.collection-filters__group-summary');
            var panel = group.querySelector('.collection-filters__group-panel');
            summary.setAttribute('aria-controls', id);
            summary.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            panel.id = id;
            /* The panel is height: 0 by default and the accordion drives it inline, so
               a re-render has to restore BOTH halves of the state. Leaving the height
               unset on a group marked expanded collapsed its contents while the icon
               showed minus, which took two clicks to recover. auto is what the
               accordion itself settles on once its transition ends. */
            panel.style.height = isOpen ? 'auto' : '0';

            var body = group.querySelector('[data-tpl-body]');

            if (f.type === 'range') {
              var price = tpl('price');
              if (price) {
                /* Constructor gives the facet's own bounds; the current selection (if
                   any) sets the thumb positions, otherwise they sit at the extremes. */
                var floor = Math.floor(Number(f.min));
                var ceiling = Math.ceil(Number(f.max));
                var chosenRange = ((selected[f.name] || [])[0] || '').split('-');
                var lo = chosenRange[0] !== undefined && chosenRange[0] !== '' ? chosenRange[0] : floor;
                var hi = chosenRange[1] !== undefined && chosenRange[1] !== '' ? chosenRange[1] : ceiling;

                price.setAttribute('data-facet-range', f.name);
                [['[data-range-min]', lo], ['[data-range-max]', hi]].forEach(function (pair) {
                  var el = price.querySelector(pair[0]);
                  if (!el) return;
                  el.min = floor;
                  el.max = ceiling;
                  el.value = pair[1];
                });
                var minField = price.querySelector('[data-price-min-field]');
                var maxField = price.querySelector('[data-price-max-field]');
                if (minField) minField.value = '$' + lo;
                if (maxField) maxField.value = '$' + hi;

                body.appendChild(price);
              }
            } else {
              var chosen = selected[f.name] || [];
              (f.options || []).forEach(function (o) {
                var option = tpl('option');
                if (!option) return;
                var oid = id + '-' + String(o.value).replace(/[^a-z0-9]+/gi, '-');
                var input = option.querySelector('.checkbox__input');
                option.setAttribute('for', oid);
                input.id = oid;
                input.value = o.value;
                input.checked = chosen.indexOf(o.value) !== -1;
                input.setAttribute('data-facet-name', f.name);
                input.setAttribute('data-facet-value', o.value);
                option.querySelector('.checkbox__label').textContent = o.display_name || o.value;
                /* Colour facets render as swatches where one exists; every other
                   facet, and any colour with no swatch, keeps the plain checkbox. */
                if (isColourFacet(f)) { applySwatch(option, o.value); }
                var count = option.querySelector('.checkbox__count');
                if (count) {
                  if (o.count == null) count.remove();
                  else count.textContent = '(' + o.count + ')';
                }
                body.appendChild(option);
              });
            }

            facetsHost.appendChild(group);
          });

          /* Wire the price slider only once the groups are in the document: the
             theme's range module queries the document, so calling it while a group is
             still detached finds nothing. It binds on load only and guards per root,
             so this is both necessary for injected controls and safe to call on every
             render. */
          if (window.esCollectionPriceRange) window.esCollectionPriceRange.init();

          renderChips(facets);
        }

        /* Applied-filter chips, with Clear all as the final item so it sits inline
           with the last row rather than dropping to its own line. */
        function renderChips(facets) {
          if (!chipsHost) return;
          var list = chipsHost.querySelector('.collection-filters__chips');
          if (!list) return;

          var labels = {};
          (facets || []).forEach(function (f) { labels[f.name] = f.display_name || f.name; });

          list.textContent = '';
          var any = false;
          Object.keys(selected).forEach(function (name) {
            (selected[name] || []).forEach(function (value) {
              var chip = tpl('chip');
              if (!chip) return;
              any = true;
              var btn = chip.querySelector('[data-facet-remove]');
              btn.setAttribute('data-facet-name', name);
              btn.setAttribute('data-facet-value', value);
              chip.querySelector('[data-tpl-label]').textContent = (labels[name] || name) + ': ' + value;
              list.appendChild(chip);
            });
          });

          if (any) {
            var clear = tpl('clear');
            if (clear) list.appendChild(clear);
          }
          chipsHost.hidden = !any;

          /* The footer's Clear tracks the chips: nothing applied, nothing to clear,
             and View results then spans the footer on its own. Scoped to the footer so
             it does not catch the Clear all inside the chip list. */
          var footerClear = document.querySelector('.collection-filters__footer [data-cnstrc-clear]');
          if (footerClear) footerClear.hidden = !any;
        }

        function toggleValue(name, value, on) {
          var current = selected[name] || [];
          var i = current.indexOf(value);
          if (on && i === -1) current.push(value);
          if (!on && i !== -1) current.splice(i, 1);
          if (current.length) selected[name] = current;
          else delete selected[name];
        }

        function changed() {
          writeUrl();
          onChange();
        }

        /* ---------- Events ----------
           Delegated, so controls rebuilt on every render keep working. */

        document.addEventListener('change', function (e) {
          if (!e.target.closest) return;

          var box = e.target.closest('[data-facet-name][type="checkbox"]');
          if (box) {
            toggleValue(box.getAttribute('data-facet-name'), box.getAttribute('data-facet-value'), box.checked);
            changed();
            return;
          }

          var sortRadio = e.target.closest('[data-cnstrc-sort-value]');
          if (sortRadio) {
            sort = sortRadio.value;
            changed();
            return;
          }

          /* Price: the slider and the Min/Max fields two-way sync inside the theme's
             range module, so either can be the trigger. Range inputs fire change on
             release, which is the right moment to re-query rather than every drag
             frame. */
          var priceRoot = e.target.closest('[data-facet-range]');
          if (priceRoot) {
            var name = priceRoot.getAttribute('data-facet-range');
            var slider = priceRoot.querySelector('[data-range-min]');
            var sliderMax = priceRoot.querySelector('[data-range-max]');
            if (!slider || !sliderMax) return;

            var digits = function (v) { return parseInt(String(v || '').replace(/[^0-9]/g, ''), 10); };
            var lo = digits(slider.value);
            var hi = digits(sliderMax.value);
            var floor = digits(slider.min);
            var ceiling = digits(slider.max);

            /* Both thumbs at the extremes means no price filter, so drop it rather
               than sending a range that matches everything. */
            if (lo <= floor && hi >= ceiling) delete selected[name];
            else selected[name] = [lo + '-' + hi];
            changed();
          }
        });

        document.addEventListener('click', function (e) {
          if (!e.target.closest) return;

          var chip = e.target.closest('[data-facet-remove]');
          if (chip) {
            toggleValue(chip.getAttribute('data-facet-name'), chip.getAttribute('data-facet-value'), false);
            changed();
            return;
          }
          if (e.target.closest('[data-cnstrc-clear]')) {
            selected = {};
            changed();
          }
        });

        /* A sort control outside the drawer reports its choice here rather than
           reaching into this module's state. */
        document.addEventListener('constructor:sort', function (e) {
          var value = e.detail && e.detail.value;
          if (value && value.indexOf('|') === -1) value = decodeSort(value);
          if (!value || value === sort) return;
          sort = value;
          changed();
        });

        if (syncUrl) readUrl();

        return {
          hasFilters: hasFilters,

          /* Adds the current filters and sort to a request params object. */
          applyTo: function (params) {
            var out = params || {};
            if (hasFilters()) out.filters = selected;
            if (sort) {
              var pair = sort.split('|');
              out.sortBy = pair[0];
              out.sortOrder = pair[1];
            }
            return out;
          },

          /* Rebuilds the drawer from a Constructor response. Skip while appending a
             further page: the facets and sort options are unchanged by paging, and
             rebuilding would drop the shopper's open group and scroll position
             mid-interaction. */
          render: function (response) {
            renderSort(response && response.sort_options);
            renderFacets(response && response.facets);
            renderCount(response && response.total_num_results);
          }
        };
      }
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["date-picker"] && !Shopify.designMode) return;
  try {
    (function () {
    var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    function root(el) { return el.closest('[data-date-picker]'); }
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function toISO(y, m, d) { return y + '-' + pad(m + 1) + '-' + pad(d); }
    function fromISO(s) {
      if (!s) return null;
      var p = s.split('-');
      if (p.length !== 3) return null;
      return { y: parseInt(p[0], 10), m: parseInt(p[1], 10) - 1, d: parseInt(p[2], 10) };
    }
    function fmt(y, m, d) { return pad(d) + ' / ' + pad(m + 1) + ' / ' + y; }
    function nowParts() { var d = new Date(); return { y: d.getFullYear(), m: d.getMonth(), d: d.getDate() }; }

    function state(node) {
      if (!node._dp) node._dp = { view: null };
      return node._dp;
    }
    function selectedISO(node) {
      return node.querySelector('[data-date-input]').value || null;
    }

    function buildSelectors(node) {
      var st = state(node);
      var monthSel = node.querySelector('[data-date-month]');
      var yearSel = node.querySelector('[data-date-year]');
      if (monthSel.options.length === 0) {
        for (var i = 0; i < 12; i++) {
          var o = document.createElement('option');
          o.value = i;
          o.textContent = MONTHS[i];
          monthSel.appendChild(o);
        }
      }
      if (yearSel.options.length === 0) {
        var thisYear = new Date().getFullYear();
        for (var y = thisYear - 100; y <= thisYear + 10; y++) {
          var oy = document.createElement('option');
          oy.value = y;
          oy.textContent = y;
          yearSel.appendChild(oy);
        }
      }
      monthSel.value = st.view.m;
      yearSel.value = st.view.y;
    }

    function bounds(node) {
      return { min: node.getAttribute('data-min') || null, max: node.getAttribute('data-max') || null };
    }

    function render(node) {
      var st = state(node);
      var days = node.querySelector('[data-date-days]');
      node.querySelector('[data-date-month]').value = st.view.m;
      node.querySelector('[data-date-year]').value = st.view.y;
      node.querySelector('[data-date-month-text]').textContent = MONTHS[st.view.m];
      node.querySelector('[data-date-year-text]').textContent = st.view.y;
      days.innerHTML = '';
      var y = st.view.y, m = st.view.m;
      var startDow = new Date(y, m, 1).getDay();
      var daysInMonth = new Date(y, m + 1, 0).getDate();
      var prevDays = new Date(y, m, 0).getDate();
      var b = bounds(node);
      var selected = selectedISO(node);
      for (var i = 0; i < 42; i++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'date-picker__day';
        var dayNum, cy = y, cm = m, other = false;
        if (i < startDow) { dayNum = prevDays - startDow + 1 + i; cm = m - 1; other = true; if (cm < 0) { cm = 11; cy = y - 1; } }
        else if (i >= startDow + daysInMonth) { dayNum = i - (startDow + daysInMonth) + 1; cm = m + 1; other = true; if (cm > 11) { cm = 0; cy = y + 1; } }
        else { dayNum = i - startDow + 1; }
        var iso = toISO(cy, cm, dayNum);
        btn.textContent = dayNum;
        btn.setAttribute('data-iso', iso);
        if (other) { btn.className += ' date-picker__day--other'; btn.disabled = true; }
        if (b.min && iso < b.min) btn.disabled = true;
        if (b.max && iso > b.max) btn.disabled = true;
        if (selected && iso === selected && !other) {
          btn.className += ' date-picker__day--selected';
          btn.setAttribute('aria-current', 'date');
        }
        days.appendChild(btn);
      }
    }

    function open(node) {
      var trig = node.querySelector('[data-date-picker-trigger]');
      var st = state(node);
      var base = fromISO(selectedISO(node)) || nowParts();
      st.view = { y: base.y, m: base.m };
      trig.setAttribute('aria-expanded', 'true');
      node.querySelector('[data-date-picker-menu]').hidden = false;
      node.classList.add('date-picker--open');
      buildSelectors(node);
      render(node);
    }

    function close(node) {
      node.querySelector('[data-date-picker-trigger]').setAttribute('aria-expanded', 'false');
      node.querySelector('[data-date-picker-menu]').hidden = true;
      node.classList.remove('date-picker--open');
    }

    /* Commit the chosen day immediately (no Done press needed). Keeps the
       popover open so the user can pick another date; Done/Close dismiss it. */
    function selectDay(node, iso) {
      var input = node.querySelector('[data-date-input]');
      var valueEl = node.querySelector('[data-date-picker-value]');
      var p = fromISO(iso);
      input.value = iso;
      valueEl.textContent = fmt(p.y, p.m, p.d);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      render(node);
    }

    document.addEventListener('click', function (e) {
      var trig = e.target.closest('[data-date-picker-trigger]');
      if (trig) {
        var n = root(trig);
        if (trig.getAttribute('aria-expanded') === 'true') { close(n); } else { open(n); }
        return;
      }
      var prev = e.target.closest('[data-date-prev]');
      if (prev) { var np = root(prev); var sp = state(np); sp.view.m--; if (sp.view.m < 0) { sp.view.m = 11; sp.view.y--; } render(np); return; }
      var next = e.target.closest('[data-date-next]');
      if (next) { var nn = root(next); var sn = state(nn); sn.view.m++; if (sn.view.m > 11) { sn.view.m = 0; sn.view.y++; } render(nn); return; }
      var day = e.target.closest('.date-picker__day');
      if (day && !day.disabled) { selectDay(root(day), day.getAttribute('data-iso')); return; }
      if (e.target.closest('[data-date-done]')) { close(root(e.target)); return; }
      if (e.target.closest('[data-date-close]')) { close(root(e.target)); return; }
      Array.prototype.forEach.call(document.querySelectorAll('[data-date-picker].date-picker--open'), function (node) {
        if (!node.contains(e.target)) close(node);
      });
    });

    document.addEventListener('change', function (e) {
      if (e.target.matches('[data-date-month]')) { var n = root(e.target); state(n).view.m = parseInt(e.target.value, 10); render(n); }
      else if (e.target.matches('[data-date-year]')) { var n2 = root(e.target); state(n2).view.y = parseInt(e.target.value, 10); render(n2); }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        Array.prototype.forEach.call(document.querySelectorAll('[data-date-picker].date-picker--open'), close);
        return;
      }
      var day = e.target.closest ? e.target.closest('.date-picker__day') : null;
      if (!day) return;
      var move = 0;
      if (e.key === 'ArrowRight') move = 1;
      else if (e.key === 'ArrowLeft') move = -1;
      else if (e.key === 'ArrowDown') move = 7;
      else if (e.key === 'ArrowUp') move = -7;
      if (move !== 0) {
        e.preventDefault();
        var btns = Array.prototype.slice.call(root(day).querySelectorAll('.date-picker__day'));
        var target = btns[btns.indexOf(day) + move];
        if (target) target.focus();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["drawer"] && !Shopify.designMode) return;
  try {
    // Global controller for all `drawer` shells (defined once). Opens any
  // <dialog class="drawer"> from a [data-drawer-trigger="<id>"] element, and
  // closes on the X, an overlay/outside click, or Escape (native). Body scroll
  // is locked while open; focus returns to the trigger on close.
  //
  // Drawers can also be opened/closed from code via window.esDrawer.open(id)
  // and window.esDrawer.close(id) - e.g. the cart drawer pops open after an
  // add-to-cart - so the scroll-lock and return-focus handling stays in one
  // place rather than each feature calling showModal() itself.
  (function () {
    if (window.__esDrawerInit) return;
    window.__esDrawerInit = true;

    var lastTrigger = null;

    function lockScroll() {
      document.documentElement.style.overflow = 'hidden';
    }

    function unlockScroll() {
      // Something underneath may still be holding the page: another drawer, or
      // the predictive search panel this drawer was opened from (it locks the
      // page on mobile and marks itself with data-scroll-locked). Releasing the
      // lock then would let the page scroll behind an overlay that is still
      // open - the closing drawer does not own the lock outright (#19502854).
      // The drawer that is closing has already dropped its own [open].
      if (document.querySelector('dialog.drawer[open], [data-scroll-locked]')) return;
      document.documentElement.style.overflow = '';
    }

    function openDrawer(dialog, trigger) {
      if (!dialog || typeof dialog.showModal !== 'function' || dialog.open) return;
      lastTrigger = trigger || null;
      dialog.showModal();
      // showModal() auto-focuses the first focusable element (the close X), which
      // shows its focus ring - a stray "box" around the X, especially on mobile.
      // Move initial focus to the panel instead (tabindex="-1", no visible ring);
      // aria-labelledby still announces the drawer. Keyboard users Tab from here,
      // so the ring only appears on genuine keyboard navigation.
      var panel = dialog.querySelector('.drawer__panel');
      if (panel && typeof panel.focus === 'function') panel.focus();
      lockScroll();
    }

    function closeDrawer(dialog) {
      if (dialog && dialog.open) dialog.close();
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-drawer-trigger]');
      if (trigger) {
        var dialog = document.getElementById(trigger.getAttribute('data-drawer-trigger'));
        if (dialog && typeof dialog.showModal === 'function') {
          event.preventDefault();
          openDrawer(dialog, trigger);
        }
        return;
      }

      var closeBtn = event.target.closest('[data-drawer-close]');
      if (closeBtn) {
        var owner = closeBtn.closest('dialog.drawer');
        if (owner && owner.open) owner.close();
        return;
      }

      // Overlay / outside click: the click landed on the dialog itself (the
      // transparent area beside the panel), not on the panel.
      if (event.target.matches && event.target.matches('dialog.drawer') && event.target.open) {
        event.target.close();
      }
    });

    // close doesn't bubble - listen in the capture phase.
    document.addEventListener('close', function (event) {
      var dialog = event.target;
      if (!dialog.matches || !dialog.matches('dialog.drawer')) return;
      unlockScroll();
      if (lastTrigger && typeof lastTrigger.focus === 'function') {
        lastTrigger.focus();
      }
      lastTrigger = null;
    }, true);

    // Programmatic open/close for any drawer by id (e.g. window.esDrawer.open('cart-drawer')).
    window.esDrawer = {
      open: function (id, trigger) {
        openDrawer(document.getElementById(id), trigger);
      },
      close: function (id) {
        closeDrawer(document.getElementById(id));
      }
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dropdown"] && !Shopify.designMode) return;
  try {
    (function () {
    function root(el) { return el.closest('[data-dropdown]'); }

    function open(node) {
      node.querySelector('[data-dropdown-trigger]').setAttribute('aria-expanded', 'true');
      node.querySelector('.dropdown__panel').hidden = false;
      node.classList.add('dropdown--open');
    }

    function close(node) {
      node.querySelector('[data-dropdown-trigger]').setAttribute('aria-expanded', 'false');
      node.querySelector('.dropdown__panel').hidden = true;
      node.classList.remove('dropdown--open');
      clearSearch(node);
    }

    function clearSearch(node) {
      var search = node.querySelector('[data-dropdown-search]');
      if (!search) return;
      search.value = '';
      var clearBtn = node.querySelector('[data-dropdown-clear]');
      if (clearBtn) clearBtn.hidden = true;
      filter(node, '');
    }

    function filter(node, query) {
      var list = node.querySelector('[data-dropdown-list]');
      var empty = node.querySelector('[data-dropdown-empty]');
      if (!list) return;
      var q = query.toLowerCase().trim();
      var visible = 0;
      Array.prototype.forEach.call(list.children, function (item) {
        var match = q === '' || item.textContent.toLowerCase().indexOf(q) !== -1;
        item.style.display = match ? '' : 'none';
        if (match) visible++;
      });
      if (empty) {
        /* Setting the text on the aria-live region announces it; clearing it
           empties the <p> so the global p:empty rule hides it. */
        empty.textContent = (visible === 0 && q !== '')
          ? empty.getAttribute('data-no-results') + ' "' + query + '"'
          : '';
      }
    }

    function updateValue(node) {
      var valueEl = node.querySelector('[data-dropdown-value]');
      if (!valueEl) return;
      var checked = node.querySelectorAll('[data-dropdown-list] input:checked');
      var labels = [];
      Array.prototype.forEach.call(checked, function (input) {
        var labelSpan = input.closest('label').querySelector('.checkbox__label, .radio__label');
        if (labelSpan) labels.push(labelSpan.textContent.trim());
      });
      if (labels.length) valueEl.textContent = labels.join(', ');
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-dropdown-trigger]');
      if (trigger) {
        var node = root(trigger);
        if (trigger.getAttribute('aria-expanded') === 'true') { close(node); } else { open(node); }
        return;
      }
      if (e.target.closest('[data-dropdown-clear]')) {
        clearSearch(root(e.target));
        return;
      }
      Array.prototype.forEach.call(document.querySelectorAll('[data-dropdown].dropdown--open'), function (node) {
        if (!node.contains(e.target)) close(node);
      });
    });

    document.addEventListener('input', function (e) {
      if (!e.target.matches('[data-dropdown-search]')) return;
      var node = root(e.target);
      var clearBtn = node.querySelector('[data-dropdown-clear]');
      if (clearBtn) clearBtn.hidden = !e.target.value;
      filter(node, e.target.value);
    });

    document.addEventListener('change', function (e) {
      var node = root(e.target);
      if (node && node.matches('[data-dropdown]')) updateValue(node);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      Array.prototype.forEach.call(document.querySelectorAll('[data-dropdown].dropdown--open'), close);
    });

    function init() {
      Array.prototype.forEach.call(document.querySelectorAll('[data-dropdown]'), updateValue);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["file-upload"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-file-upload]').forEach(function (root) {
    var input = root.querySelector('[data-file-input]');
    var dropzone = root.querySelector('[data-file-dropzone]');
    var list = root.querySelector('[data-file-list]');
    if (!input || !list) return;

    function formatSize(bytes) {
      if (bytes < 1024) return bytes + ' B';
      if (bytes < 1048576) return Math.round(bytes / 1024) + ' KB';
      return (bytes / 1048576).toFixed(1) + ' MB';
    }

    function render() {
      list.innerHTML = '';
      var files = input.files;
      list.hidden = !files || files.length === 0;
      Array.prototype.forEach.call(files, function (file) {
        var li = document.createElement('li');
        li.className = 'file-upload__item';
        var name = document.createElement('span');
        name.className = 'file-upload__name';
        name.textContent = file.name;
        var size = document.createElement('span');
        size.className = 'file-upload__size';
        size.textContent = formatSize(file.size);
        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'file-upload__remove';
        remove.setAttribute('aria-label', 'Remove ' + file.name);
        remove.textContent = '\u2715';
        remove.addEventListener('click', function () {
          input.value = '';
          render();
          input.focus();
        });
        li.appendChild(name);
        li.appendChild(size);
        li.appendChild(remove);
        list.appendChild(li);
      });
    }

    input.addEventListener('change', render);

    if (dropzone) {
      ['dragenter', 'dragover'].forEach(function (evt) {
        dropzone.addEventListener(evt, function (e) {
          e.preventDefault();
          dropzone.classList.add('is-dragover');
        });
      });
      ['dragleave', 'drop'].forEach(function (evt) {
        dropzone.addEventListener(evt, function (e) {
          e.preventDefault();
          if (evt === 'dragleave' && dropzone.contains(e.relatedTarget)) return;
          dropzone.classList.remove('is-dragover');
        });
      });
      dropzone.addEventListener('drop', function (e) {
        if (e.dataTransfer && e.dataTransfer.files.length) {
          input.files = e.dataTransfer.files;
          render();
        }
      });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-account"] && !Shopify.designMode) return;
  try {
    class AccountTooltip extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[data-account-trigger]');
      this.panel = this.querySelector('[data-account-panel]');
      if (!this.trigger || !this.panel) return;

      this.onTriggerClick = this.onTriggerClick.bind(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);

      this.trigger.addEventListener('click', this.onTriggerClick);
      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('keydown', this.onKeydown);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('keydown', this.onKeydown);
    }

    get open() {
      return this.hasAttribute('open');
    }

    set open(value) {
      if (value) {
        this.setAttribute('open', '');
        this.panel.hidden = false;
        this.trigger.setAttribute('aria-expanded', 'true');
      } else {
        this.removeAttribute('open');
        this.panel.hidden = true;
        this.trigger.setAttribute('aria-expanded', 'false');
      }
    }

    onTriggerClick(event) {
      event.preventDefault();
      this.open = !this.open;
    }

    onDocumentClick(event) {
      if (!this.open) return;
      if (this.contains(event.target)) return;
      this.open = false;
    }

    onKeydown(event) {
      if (event.key === 'Escape' && this.open) {
        this.open = false;
        this.trigger.focus();
      }
    }
  }

  if (!customElements.get('account-tooltip')) {
    customElements.define('account-tooltip', AccountTooltip);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-mega-promo"] && !Shopify.designMode) return;
  try {
    (function () {
    // Promo clips play only while their panel is actually visible.
    //
    // The markup deliberately carries no `autoplay` (see the comment beside the
    // video_tag call): with `autoplay` the browser must fetch media data to
    // start playback, which defeats `preload="none"` and had every page of the
    // site downloading the full video source for a promo inside a closed
    // dropdown. Playback is driven from here instead.
    //
    // Visibility is tested rather than inferred from any particular panel's
    // open state, because the same card renders in two surfaces that hide
    // themselves differently: the desktop mega panel uses
    // `opacity: 0; visibility: hidden` (only >=1104px), and the mobile drawer
    // panel uses `visibility: hidden` at every width. Two checks cover both,
    // plus any surface added later:
    //   - computed `visibility` inherits, so an ancestor hiding the panel makes
    //     the video's own computed value `hidden` without us naming the ancestor;
    //   - `getClientRects()` is empty under a `display: none` ancestor, which is
    //     how the mega menu is hidden below 1104px.
    if (window.__esMegaPromoVideo) return;
    window.__esMegaPromoVideo = true;

    // Matched structurally rather than by an added class: the stylesheet above
    // already targets `.header__mega-promo-media video`, so this selector is
    // guaranteed to hold for as long as the markup does, and it does not depend
    // on `video_tag` honouring a `class` parameter.
    var SELECTOR = '.header__mega-promo-media video';

    function isVisible(video) {
      if (video.getClientRects().length === 0) return false;
      return window.getComputedStyle(video).visibility !== 'hidden';
    }

    function sync(root) {
      var videos = (root || document).querySelectorAll(SELECTOR);
      Array.prototype.forEach.call(videos, function (video) {
        if (isVisible(video)) {
          if (!video.paused) return;
          var played = video.play();
          // Muted playback is allowed without a gesture, so a rejection here is
          // not expected - swallowed the same way the predictive-search category
          // videos do, so a blocked play never throws into the console.
          if (played && played.catch) played.catch(function () {});
        } else if (!video.paused) {
          video.pause();
        }
      });
    }

    var observer = null;

    // Re-pointed rather than re-registered on section reload: the theme editor
    // replaces the whole header element, which leaves the old observer watching
    // a detached node. The document-level listeners below are attached once and
    // survive, so only the observer needs rebinding.
    function attach() {
      var header = document.querySelector('[data-header]');
      if (!header) return;
      if (observer) observer.disconnect();
      // Panels announce themselves by attribute: `open` on <mega-menu>, and
      // `class`/`inert` on the drawer panels. Watching those on the header
      // subtree catches every open and close without coupling this to either
      // controller.
      observer = new MutationObserver(function () {
        sync(header);
      });
      observer.observe(header, {
        subtree: true,
        attributes: true,
        attributeFilter: ['open', 'class', 'hidden', 'inert'],
      });
      sync(header);
    }

    function init() {
      attach();
      // The desktop panel fades, so its computed visibility flips at the end of
      // the transition rather than when the attribute changes. transitionend
      // bubbles, so one document-level listener covers every panel.
      document.addEventListener('transitionend', function (event) {
        if (event.propertyName === 'visibility' || event.propertyName === 'opacity') sync(document);
      });
      // Crossing the 1104px breakpoint swaps which surface is displayed.
      window.matchMedia('(min-width: 1104px)').addEventListener('change', function () {
        sync(document);
      });
      document.addEventListener('shopify:section:load', attach);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hero-media"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__esHeroMediaMotion) return;
    window.__esHeroMediaMotion = true;

    // The videos carry `autoplay` (plus `muted` and `playsinline`) in the
    // markup, so the browser starts them on its own - the same way every other
    // site's hero video works. This is only belt and braces for a browser that
    // has deferred the attribute, and it is unconditional: nothing in here may
    // decide NOT to play, or it would fight the attribute (#1137).
    function apply(root) {
      var videos = (root || document).querySelectorAll('.hero-media__video');
      Array.prototype.forEach.call(videos, function (v) {
        if (!v.paused) return;
        var p = v.play();
        // One line, so the next person investigating "the video did not start"
        // is not looking at a silent failure the way we were on #1137.
        if (p && p.catch) {
          p.catch(function (err) {
            console.warn('[hero-media] video did not start:', err && err.name ? err.name : err);
          });
        }
      });
    }

    function init() { apply(document); }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (e) { apply(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["image-warm"] && !Shopify.designMode) return;
  try {
    // Shared image warming. See the doc header in snippets/image-warm.liquid for
  // why warming the element (rather than a URL we construct) is what makes the
  // warmed file provably the one the reveal will use.
  (function () {
    if (window.esrWarmImages) return;

    // Two at a time. A six-size product would otherwise open six large
    // requests at once and starve whatever the shopper is actually looking at.
    var MAX_IN_FLIGHT = 2;
    var queue = [];
    var inFlight = 0;

    function pump() {
      while (inFlight < MAX_IN_FLIGHT && queue.length) {
        start(queue.shift());
      }
    }

    function start(img) {
      inFlight++;
      var done = function () {
        img.removeEventListener('load', done);
        img.removeEventListener('error', done);
        inFlight--;
        pump();
      };
      img.addEventListener('load', done);
      img.addEventListener('error', done);

      // Layers that withhold their URL (Finishes) hand it over first. The
      // srcset goes on before the src so the browser picks against `sizes`
      // rather than fetching the fallback and re-selecting.
      var srcset = img.getAttribute('data-srcset');
      if (srcset) {
        img.setAttribute('srcset', srcset);
        img.removeAttribute('data-srcset');
      }
      var src = img.getAttribute('data-src');
      if (src) {
        img.setAttribute('src', src);
        img.removeAttribute('data-src');
      }

      // Both paths still need the lazy flip - handing a Finishes layer its src
      // is not enough while the layer itself is below the fold.
      //
      // Order matters: changing `loading` to eager runs the element's lazy load
      // resumption steps synchronously, and the request reads its priority as
      // it is created. Set the priority first or it is read too late.
      img.fetchPriority = 'low';
      if (img.loading === 'lazy') img.loading = 'eager';

      // An image already in cache fires neither load nor error again.
      if (img.complete) done();
    }

    // Start fetching a set of images, cheapest-to-reason-about first: anything
    // already warmed, already complete, or with nothing to fetch is skipped.
    window.esrWarmImages = function (imgs) {
      if (!imgs) return;
      Array.prototype.forEach.call(imgs, function (img) {
        if (!img || img.__esWarmed) return;
        img.__esWarmed = true;
        if (img.complete && !img.hasAttribute('data-src')) return;
        queue.push(img);
      });
      pump();
    };

    // Skip speculative warming when the shopper has asked us not to spend their
    // data. Intent warming ignores this - by then they have asked for the image.
    function shouldSkipSpeculative() {
      var c = navigator.connection;
      if (!c) return false;
      if (c.saveData) return true;
      return /^(slow-2g|2g|3g)$/.test(c.effectiveType || '');
    }

    // Warm as `root` comes within about two screens, then wait for an idle
    // moment. Deliberately not window.load: on this theme load is dominated by
    // third parties, so it fires unpredictably and usually while the shopper is
    // still at the top of the page, where these fetches would compete with the
    // gallery. Returns a disposer - call it from disconnectedCallback or the
    // theme editor leaks an observer on every re-render.
    window.esrWarmWhenNear = function (root, getImgs) {
      if (!root || shouldSkipSpeculative() || !window.IntersectionObserver) return function () {};

      var observer = new window.IntersectionObserver(function (entries) {
        if (!entries.some(function (e) { return e.isIntersecting; })) return;
        observer.disconnect();
        var run = function () { window.esrWarmImages(getImgs()); };
        if (window.requestIdleCallback) {
          // The timeout is not optional - idle periods can be starved
          // indefinitely inside the theme editor's iframe.
          window.requestIdleCallback(run, { timeout: 2000 });
        } else {
          setTimeout(run, 1000);
        }
      }, { rootMargin: '200% 0px' });

      observer.observe(root);
      return function () { observer.disconnect(); };
    };

    // Warm what a control is about to reveal, the moment the shopper reaches for
    // it. Costs nothing speculatively - nothing downloads until they show intent
    // - and buys 100-500ms on a pointer, 80-150ms on a tap.
    window.esrWarmOnIntent = function (triggers, resolve) {
      if (!triggers) return;
      Array.prototype.forEach.call(triggers, function (trigger) {
        if (!trigger) return;
        var warm = function () { window.esrWarmImages(resolve(trigger)); };
        trigger.addEventListener('pointerenter', warm, { once: true });
        trigger.addEventListener('focus', warm, { once: true });
        trigger.addEventListener('touchstart', warm, { once: true, passive: true });
      });
    };

    // Sections cannot call the three functions above at connect time. Shopify
    // emits section JS in compiled_assets/scripts.js and snippet JS in
    // compiled_assets/snippet-scripts.js, both deferred, and scripts.js is
    // ordered first - so a section's connectedCallback runs, and its custom
    // element upgrades, before this file has executed. A section that looked
    // window.esrWarmWhenNear up at connect would read undefined and silently
    // never warm anything. Same trap 80beb2be fixed for the ETA module.
    //
    // So sections push a registration function onto this queue instead - one
    // line, no lookup, safe to run before this file exists. Draining it here
    // and then swapping the array for a run-on-push shim means a section that
    // connects LATER (the theme editor re-rendering one) registers immediately
    // rather than sitting in a queue nothing drains again.
    var queued = window.__esWarmQueue || [];
    window.__esWarmQueue = { push: function (fn) { fn(); } };
    queued.forEach(function (fn) { fn(); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pagination-nav"] && !Shopify.designMode) return;
  try {
    // Shoppers page with Load more, so the links come out of the layout as soon as
  // JS is running. Left in the DOM until then (and permanently without JS) so the
  // deeper pages stay reachable - see the snippet's doc header.
  //
  // Managed navs are skipped: their section hides them itself, because it knows
  // something this file cannot - whether its own pager actually came up.
  (function () {
    function hideCrawlNav() {
      var navs = document.querySelectorAll('[data-pagination-nav]:not([data-pagination-nav-managed])');
      for (var i = 0; i < navs.length; i++) navs[i].hidden = true;
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', hideCrawlNav);
    } else {
      hideCrawlNav();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["predictive-search"] && !Shopify.designMode) return;
  try {
    class PredictiveSearch extends HTMLElement {

    connectedCallback() {
      this.panel = this.querySelector('[data-predictive-panel]');
      this.desktopField = this.querySelector('[data-search-field]');
      this.heading = this.querySelector('.predictive-search__heading');
      this.idleTitle = this.querySelector('[data-predictive-idle]');
      this.resultsBar = this.querySelector('[data-predictive-results-heading]');
      this.noResults = this.querySelector('[data-predictive-no-results]');
      this.noResultsTitle = this.querySelector('[data-predictive-no-results-title]');
      this.products = this.querySelector('[data-predictive-products]');
      this.liveProducts = this.querySelector('[data-ps-products-list]');
      this.categories = this.querySelector('[data-predictive-categories]');
      this.suggestionsList = this.querySelector('[data-ps-suggestions]');
      this.categoriesList = this.querySelector('[data-ps-categories]');
      /* Read off the group class, not the live list: with "Show search term
         suggestions" off the list isn't rendered at all, and the group still has
         to be addressable so the results state can collapse the column. */
      this.suggestionsGroup = this.querySelector('.predictive-search__group--trending');
      this.categoriesGroup = this.categoriesList ? this.categoriesList.closest('.predictive-search__group') : null;
      this.asideDivider = this.querySelector('.predictive-search__divider');
      this.aside = this.querySelector('.predictive-search__aside');
      this.suggestionsTab = this.querySelector('[data-search-tab="trending"]');
      this.categoriesTab = this.querySelector('[data-search-tab="rooms"]');

      this.cnstrcToken = 0;
      this.cnstrcResultId = null;
      this.currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AUD';

      // Live results present? Drives hiding of empty live groups in the results
      // state (e.g. S&D has no query suggestions yet) and the "no products"
      // vs full "no results" split.
      //
      /* Both aside columns are Constructor-served, and since 11 Sept 2026 both come
         from the SAME autocomplete response: suggestions from its `Search
         Suggestions` section (or the popular-searches pod when idle), categories
         from its `Categories` section. The Shopify path assumes both are present
         until a
         response proves otherwise, which is right when the static merchant menus
         back them. Constructor has no static fallback, so assuming presence would
         paint an empty Suggestions column on first open - start from nothing and let
         each response turn its own column on. */
      /* Merchant switch (header section > Predictive search). While it is off the
         `hasSuggestions` getter always reads false, so every state rule that hides
         an empty suggestions column already hides the switched-off one - both data
         layers, both breakpoints - with no extra branching. */
      this.suggestionsEnabled = this.getAttribute('data-show-suggestions') !== 'false';

      this.hasSuggestions = !this.cnstrcMode;
      this.hasCollections = !this.cnstrcMode;
      this.hasProducts = false;
      this.viewAll = this.querySelector('[data-ps-view-all]');
      this.staticEls = Array.prototype.slice.call(this.querySelectorAll('[data-ps-static]'));
      this.liveEls = Array.prototype.slice.call(this.querySelectorAll('[data-ps-live]'));
      // Any category card can carry a video. Gated by syncVideo so they only
      // play while actually on screen (open + no-results state + desktop).
      this.categoryVideos = this.categories ? Array.prototype.slice.call(this.categories.querySelectorAll('video')) : [];
      this.status = this.querySelector('[data-predictive-status]');
      this.tabButtons = Array.prototype.slice.call(this.querySelectorAll('[data-search-tab]'));
      this.noResultsLabel = this.getAttribute('data-no-results-label') || '';
      this.noProductsLabel = this.getAttribute('data-no-products-label') || '';

      this.suggestUrl = this.getAttribute('data-suggest-url') || '/search/suggest';
      this.searchUrl = this.getAttribute('data-search-url') || '/search';
      this.resultsSection = this.getAttribute('data-results-section') || '';

      /* The merchant's Constructor pods for the idle state (header section settings).
         An empty string means that pod is switched off: skip the request and keep the
         Liquid-rendered fallback, never call a pod with a blank id. */
      this.pods = {
        products: this.getAttribute('data-pod-products') || '',
        suggestions: this.getAttribute('data-pod-suggestions') || '',
      };
      this.debounceTimer = null;
      this.controller = null;

      // The mobile trigger is the separate full-width search row in the header.
      var header = this.closest('.header');
      this.mobileField = header ? header.querySelector('.header__search--mobile [data-search-field]') : null;
      this.mobileSearch = this.mobileField ? this.mobileField.closest('[data-search]') : null;

      if (!this.panel || (!this.desktopField && !this.mobileField)) return;

      this.mql = window.matchMedia('(min-width: 1104px)');
      this.fields = [this.desktopField, this.mobileField].filter(Boolean);

      this.open = this.open.bind(this);
      this.close = this.close.bind(this);
      this.onInput = this.onInput.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onBreakpoint = this.onBreakpoint.bind(this);

      this.fields.forEach(function (field) {
        field.setAttribute('aria-expanded', 'false');
        field.setAttribute('aria-controls', this.panel.id);
        field.addEventListener('focus', this.open);
        field.addEventListener('click', this.open);
        field.addEventListener('input', this.onInput);
      }, this);

      // Close buttons live in each field's .search wrapper (desktop inside this
      // element, mobile in the external search row).
      this.closeButtons = Array.prototype.slice.call(document.querySelectorAll('[data-search-close]')).filter(function (btn) {
        return this.contains(btn) || (this.mobileSearch && this.mobileSearch.contains(btn));
      }, this);
      this.closeButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          // close() returns focus to the active field (the button is hidden on close).
          this.close();
        }.bind(this));
      }, this);

      // Tabs (mobile only; default to the first available group).
      this.tabButtons.forEach(function (tab) {
        tab.addEventListener('click', function () {
          this.activateTab(tab.getAttribute('data-search-tab'));
        }.bind(this));
      }, this);
      if (this.tabButtons.length) {
        this.activateTab(this.tabButtons[0].getAttribute('data-search-tab'));
      }

      // Escape is bound at document level so it works whether focus is in the
      // panel (inside this element) or on the external mobile search field.
      document.addEventListener('keydown', this.onKeydown);
      document.addEventListener('click', this.onDocumentClick);
      this.mql.addEventListener('change', this.onBreakpoint);

      /* Provenance class: makes it obvious in devtools which engine populated the
         drawer. Set here rather than in Liquid because a param shadows the global
         settings object in this snippet. */
      if (this.panel) {
        this.panel.classList.add(this.cnstrcMode
          ? 'predictive-search__panel--constructor'
          : 'predictive-search__panel--shopify');
      }

      /* Constructor mode hides the idle grid until the pod has been resolved, so the
         swap to its cards is a fade rather than a flash. Added in JS, not Liquid, so a
         broken bundle or blocked SDK can never leave the featured collection invisible -
         without this class the grid paints immediately, which is also what the
         Shopify-powered drawer always does. */
      if (this.cnstrcMode && this.products) {
        this.products.classList.add('predictive-search__cards--pending');
      }

      /* Constructor: report which autocomplete item was chosen. Delegated on the
         panel so it covers both the product grid and the suggestion list, and uses
         mousedown so the event is sent before the navigation starts. */
      if (this.cnstrcMode && this.panel) {
        this.panel.addEventListener('mousedown', function (event) {
          /* The theme's standard product card is what Constructor results render as
             (hydrated by `esrConstructor.hydrateAll`), and it carries the item
             attributes this reads. */
          var card = event.target.closest('.product-card');
          if (card) {
            /* Results state only. The same card markup serves the zero state, which is
               a recommendations container - autotrack derives that click from the
               container attributes, and a manual autocomplete-select there would file a
               pod impression as a search interaction. */
            if (this.getAttribute('data-state') !== 'results') return;
            this.trackConstructor('trackAutocompleteSelect', card.getAttribute('data-cnstrc-item-name'), {
              originalQuery: this.currentQuery(),
              section: 'Products'
            });
            return;
          }
          var suggestion = event.target.closest('[data-ps-suggestions] a');
          if (suggestion) {
            this.trackConstructor('trackAutocompleteSelect', suggestion.textContent.trim(), {
              originalQuery: this.currentQuery(),
              section: 'Search Suggestions'
            });
          }
        }.bind(this));
      }

      this.setState('idle');
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
      document.removeEventListener('click', this.onDocumentClick);
      if (this.mql) this.mql.removeEventListener('change', this.onBreakpoint);
      this.abort();
      this.unlockScroll();
    }

    get isOpen() {
      return this.hasAttribute('open');
    }

    /* Live suggestions present? Stored raw by whichever data layer answered, then
       gated by the merchant switch on read, so "switched off" and "nothing came
       back" are one case for every consumer. */
    get hasSuggestions() {
      return this.suggestionsEnabled && this.hasSuggestionsRaw;
    }

    set hasSuggestions(value) {
      this.hasSuggestionsRaw = !!value;
    }

    // Only one field is visible per breakpoint; that one drives the panel.
    get activeField() {
      if (this.mql && this.mql.matches) return this.desktopField || this.mobileField;
      return this.mobileField || this.desktopField;
    }

    get activeCloseBtn() {
      var field = this.activeField;
      if (!field) return null;
      var wrap = field.closest('[data-search]');
      return wrap ? wrap.querySelector('[data-search-close]') : null;
    }

    currentQuery() {
      var field = this.activeField;
      return field ? field.value.trim() : '';
    }

    activateTab(name) {
      if (!name) return;
      this.setAttribute('data-active-tab', name);
      this.tabButtons.forEach(function (tab) {
        tab.setAttribute('aria-pressed', tab.getAttribute('data-search-tab') === name ? 'true' : 'false');
      });
    }

    // If the currently active mobile tab is hidden (its live group is empty),
    // switch to the first tab that is still visible.
    ensureVisibleTab() {
      var active = this.getAttribute('data-active-tab');
      var current = this.tabButtons.filter(function (t) {
        return t.getAttribute('data-search-tab') === active;
      })[0];
      if (current && !current.hidden) return;
      var next = this.tabButtons.filter(function (t) { return !t.hidden; })[0];
      if (next) this.activateTab(next.getAttribute('data-search-tab'));
    }

    /* Mobile: the fixed panel hangs from the bottom of the SEARCH ROW, which is
       not always the bottom of the header.

       Once the header collapses, .header__search--mobile is taken out of flow
       (position: absolute, top: 100%) and slid up behind the bar, so revealing it
       is a transform rather than a page reflow (#965). The header's own box is
       then just the bar - around 64px - while the row hangs BELOW that edge. So
       measuring the header alone placed the panel at the bar's bottom, tucked
       underneath the very row the shopper had just tapped. At the top of the page
       the row is still in flow and the header bottom includes it, which is why
       this only ever went wrong once scrolled (#830).

       Taking whichever edge sits lower is correct in every state: in flow the two
       agree; collapsed and peeked the row is lower and wins; collapsed and hidden
       the row sits behind the bar and the bar wins. */
    setMobileTop() {
      var header = this.closest('.header');
      if (!header || !this.panel) return;
      var bottom = header.getBoundingClientRect().bottom;
      var row = header.querySelector('.header__search--mobile');
      if (row) {
        var rowBottom = row.getBoundingClientRect().bottom;
        if (rowBottom > bottom) bottom = rowBottom;
      }
      // Set on the header so both the panel and the header's page-dim overlay
      // inherit it (the overlay starts at the same edge on mobile).
      /* Floored to a whole pixel. A rect bottom is fractional, and a fractional
         top can leave a hairline of the page showing between the header and the
         panel; flooring biases the other way, so the panel's edge tucks under
         the header instead. */
      header.style.setProperty('--ps-top', Math.floor(Math.max(0, bottom)) + 'px');
    }

    /* The row slides down over 0.3s, so a measurement taken as search opens
       describes a position it is still travelling away from, and nothing else
       would correct it - the transform changes no box size, so a ResizeObserver
       never fires, and the visual viewport does not move either. Re-measure on
       the frame after paint, when the transform finishes, and whenever the header
       changes state, which is what flips the row between hidden and revealed. */
    trackHeader() {
      var header = this.closest('.header');
      if (!header) return;
      var self = this;
      this._remeasure = function () { self.setMobileTop(); };
      requestAnimationFrame(this._remeasure);
      var row = header.querySelector('.header__search--mobile');
      if (row) {
        this._headerRow = row;
        row.addEventListener('transitionend', this._remeasure);
      }
      this._headerObserver = new MutationObserver(this._remeasure);
      this._headerObserver.observe(header, { attributes: true, attributeFilter: ['class'] });
    }

    untrackHeader() {
      if (this._headerObserver) {
        this._headerObserver.disconnect();
        this._headerObserver = null;
      }
      if (this._headerRow && this._remeasure) {
        this._headerRow.removeEventListener('transitionend', this._remeasure);
      }
      this._headerRow = null;
      this._remeasure = null;
    }

    lockScroll() {
      /* NEVER move the document to lock it. This used to pin the body with
         `position: fixed; top: -<scrollY>px`, which relaid the page out the
         instant the field took focus - and iOS Safari drops an in-progress focus
         when its target is moved out from under the finger. The keyboard never
         opened and the panel never appeared, so tapping search did nothing. It
         only showed when the page was scrolled, because at the top `-0px` moves
         nothing, and only on iOS: every other engine tolerates the relayout.
         Task #19043403.

         overflow:hidden on <html> alone does NOT hold on iOS - it keeps
         touch-scrolling the page behind this custom (non-native-dialog) overlay -
         so swallow touch moves that did not start inside the panel as well. That
         holds the background still without shifting it by a single pixel. */
      document.documentElement.style.overflow = 'hidden';
      /* Advertise the lock, so an overlay that opens ON TOP of search - the
         range modal, opened from one of the result cards - can tell on its own
         close that this panel still needs the page held, and leaves the lock
         alone instead of clearing it out from under an open search (#19502854). */
      this.setAttribute('data-scroll-locked', '');
      var self = this;

      /* A gesture is judged once, on its first few pixels, and that verdict holds
         for the rest of the drag (#830). Two things have to be true for a move to
         be let through: it started inside something that can actually scroll
         sideways, and it is going sideways.

         Both halves matter. Exempting the carousel and the tab row by element
         alone would let a VERTICAL drag that happens to start on a card pan the
         whole view again, which is the fault Alex just confirmed fixed. Judging
         by axis alone would exempt sideways drags over content that cannot
         scroll, for no benefit. Together: horizontal swipes on the strips work,
         everything vertical stays dead.

         The scroller is found by measuring at touchstart rather than by matching
         class names - scrollWidth against clientWidth is true of a real scroller
         whatever it is called, so this does not rot when the markup changes. The
         verdict is latched so a swipe that drifts off-axis mid-flick does not
         suddenly hand the page back to iOS. */
      this._hScroller = function (node) {
        var el = node;
        while (el && el !== self.panel && el.nodeType === 1) {
          if (el.scrollWidth > el.clientWidth + 1) {
            var ox = window.getComputedStyle(el).overflowX;
            if (ox === 'auto' || ox === 'scroll') return el;
          }
          el = el.parentElement;
        }
        return null;
      };

      this._onTouchStart = function (e) {
        var t = e.touches && e.touches[0];
        self._gesture = t
          ? { x: t.clientX, y: t.clientY, scroller: self._hScroller(e.target), axis: null, exempt: false, blurred: false }
          : null;
      };

      this._onTouchEnd = function () {
        self._gesture = null;
        self.resetDrawerScrollIfPending();
      };

      this._onTouchMove = function (e) {
        /* ANY finger movement dismisses the keyboard. Not a scroll event, not a
           visual-viewport event - the touch itself.

           Both of those were tried and neither caught it on the device. The
           panel's scroll event does not fire when the BROWSER pans rather than
           the panel; the visual viewport's own scroll event did not reach us
           either. A touchmove cannot miss: whatever is moving - the page, the
           browser's own viewport, or nothing at all - the finger moved, and that
           is the thing being detected.

           It also removes the need for the machinery that came before it. A
           keyboard opening produces no touchmove, because no finger moved, so
           there is nothing to tell apart and no grace window to tune: the
           previous version needed 600ms of it purely to avoid dismissing the
           keyboard on the pan the keyboard itself caused.

           Threshold, not first pixel, so a tap that trembles does not count.
           Once per gesture, and blur only - no scroll call in the same frame,
           which is what invites Safari to pan again. */
        var g0 = self._gesture;
        var t0 = e.touches && e.touches[0];
        if (g0 && t0) {
        }
        if (g0 && t0 && !g0.blurred) {
          if (Math.abs(t0.clientX - g0.x) > 12 || Math.abs(t0.clientY - g0.y) > 12) {
            g0.blurred = true;
            var focused = document.activeElement;
            if (focused && self._ownsField && self._ownsField(focused) && typeof focused.blur === 'function') {
              if (focused.matches('input, textarea')) {
                focused.blur();
              }
            }
          }
        }

        /* Panel-origin moves are swallowed too (#830). This used to exempt them
           so the panel could scroll its own results - but the panel is no longer
           scrollable, so the exemption stopped buying anything and instead handed
           iOS the one gesture it uses to pan: a drag starting inside the overlay
           with nothing to consume it panned the whole rendered view, page and
           header and all, however well the document itself was held. With the
           move cancelled there is nothing for the pan to ride on.
           Taps are untouched - this is touchmove only, so buttons, links and the
           cards all still work normally. */
        /* A modal dialog is in the top layer, which is ABOVE this overlay, not
           behind it - so it is not part of "the page" this lock holds still.
           Cancelling its touches froze the range modal opened from a result
           card: its product strip could not be swiped at all (#19502854). */
        if (e.target && e.target.closest && e.target.closest('dialog[open]')) return;
        var g = self._gesture;
        var t = e.touches && e.touches[0];

        /* A gesture that began inside a genuine horizontal scroller is handed to
           the browser, and crucially is NOT cancelled while we work out which way
           it is going.

           That waiting period was the bug Alex hit as "it works, but takes a few
           attempts". The axis used to be latched once the finger had travelled a
           few pixels, and until then every move was cancelled - but cancelling
           the OPENING move of a gesture makes the browser abandon native
           scrolling for the whole of it. So a swipe only took if its very first
           sampled move was already flat and fast; an ordinary thumb swipe, which
           starts slow and slightly downward, was killed before it began and had
           to be repeated until one happened to start flat enough.

           Nothing needs to be measured now anyway: touch-action: pan-x on the
           strip lets the browser permit sideways panning and forbid vertical, so
           the page cannot move whichever way the finger goes.

           The check below is only a fallback for an engine that ignores
           touch-action. It waits for a drag that is unmistakably vertical, which
           keeps it clear of any sideways swipe, and by then the scroll decision
           has long been made so being late costs nothing. */
        /* The panel body scrolls now, so a drag that starts inside the panel is
           the shopper scrolling their results - not the page-pan this handler was
           written to stop. It is left alone, and the page behind is held by
           overflow:hidden on <html> plus overscroll-behavior on the panel, which
           is what stops the scroll chaining out at either end.

           Everything OUTSIDE the panel is still swallowed, which is the part
           that mattered: that is the drag that used to move the whole view. */
        /* HARD LOCK, restored. Only a touch inside the drawer - the one element
           allowed to scroll - is let through. Everything else is swallowed,
           including a drag on the panel outside the drawer, which is what used
           to let the browser take the whole view.

           v1 exempted the whole panel and that was too generous: the panel is
           the fixed frame, so a drag on it had nothing to scroll and went
           straight to the browser. */
        var drawer = self.querySelector('.predictive-search__drawer');
        if (drawer && drawer.contains(e.target)) return;

        if (g && g.scroller && t) {
          var sx = Math.abs(t.clientX - g.x);
          var sy = Math.abs(t.clientY - g.y);
          if (sy > 24 && sy > sx * 2) {
            e.preventDefault();
            return;
          }
          return;
        }

        // Everywhere else in the panel there is nothing to scroll, so every move
        // is still swallowed outright - that is what holds the page still.
        e.preventDefault();
      };
      document.addEventListener('touchstart', this._onTouchStart, { passive: true });
      document.addEventListener('touchend', this._onTouchEnd, { passive: true });
      document.addEventListener('touchcancel', this._onTouchEnd, { passive: true });
      document.addEventListener('touchmove', this._onTouchMove, { passive: false });
      this.trackViewport();
    }

    /* The keyboard does not change the LAYOUT viewport, it shrinks and pans the
       VISUAL one. Everything here is position:fixed, which anchors to the layout
       viewport, so with the keyboard up the panel and the scrim keep their old
       geometry and the whole composition slides under a smaller window: the scrim
       edge drifts inward, anything fixed to the bottom lands mid-screen, and the
       header pans off the top (#19449070).

       No CSS length fixes this. vh, svh, lvh and dvh all describe the layout
       viewport and the browser's own chrome - none of them shrink for a keyboard.
       window.visualViewport is the only thing that reports the real visible
       rectangle, so it is published as custom properties for the CSS to use.

       Deliberately ONLY sets custom properties. It does not move, resize or
       reflow the document: doing that during focus is what broke search outright
       on iOS before (task #19043403 - the body was pinned with position:fixed,
       the page relaid out the instant the field took focus, and iOS drops an
       in-progress focus when its target moves out from under the finger, so the
       keyboard never opened). Custom properties are safe because they change
       nothing about the document's own box. */
    /* Item 8: the keyboard gets out of the way on a tap or a scroll inside the
       panel. Blurring the field is what dismisses it - there is no API to close
       the keyboard directly - so the field is only blurred, never re-focused,
       and the panel stays open either way.

       A tap on something interactive is left alone: tapping a suggestion should
       follow it, and tapping the field itself obviously must not dismiss the
       keyboard the tap just asked for. The scroll listener is passive, so it can
       never delay the scroll it is watching. */
    /* Return the drawer to the top after a scroll has dismissed the keyboard.

       While the keyboard is up the drawer is capped short, so a small scroll
       reaches lower content. When the dismissal drops the keyboard the cap
       releases and the drawer grows, but it keeps the offset from the gesture -
       leaving the heading and the first row of chips cut off above the top edge
       of a drawer that may no longer overflow at all.

       Deferred, not immediate, on two conditions. The finger may still be down,
       since the gate that fixed the reopen loop lets a dismissal fire mid-drag,
       and writing scrollTop under a live gesture fights the scroll still in
       flight. And the keyboard may not have finished leaving, so the cap has
       not released yet. Both are checked here rather than guessed at with a
       timer, and this runs from both the viewport settling and the finger
       lifting, because either can happen last.

       Smooth, per the client. The deferral is what makes that safe - see the
       note at the call itself. */
    resetDrawerScrollIfPending() {
      if (!this._pendingScrollReset) return;
      if (this._gesture) return;
      var vv = window.visualViewport;
      if (vv && Math.abs(vv.height - window.innerHeight) > 2) return;
      var drawer = this._dismissScroller || this.querySelector('.predictive-search__drawer');
      if (drawer) {
        /* Smooth, which the deferral above is what makes safe: by the time this
           runs the keyboard has gone and the finger is up, so the animation has
           nothing left to fight and no collapse to stutter against.

           Feature-detected rather than assumed. Safari honours behavior:smooth
           on an element from 15.4; older engines ignore the options object and
           read the call as scrollTo(x, y), which lands somewhere unintended, so
           they take the plain assignment instead. */
        if ('scrollBehavior' in document.documentElement.style && typeof drawer.scrollTo === 'function') {
          drawer.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          drawer.scrollTop = 0;
        }
      }
      this._pendingScrollReset = false;
    }

    trackKeyboardDismiss() {
      if (!this.panel) return;
      var self = this;
      var field = this.mobileField || this.desktopField;

      /* THE FAULT ALL SIX ROUNDS DIED ON. The mobile search field is not inside
         this element: the header renders `.header__search--mobile` as a sibling
         of <predictive-search>, so on mobile document.activeElement is outside
         it and `self.contains(active)` is false for the only field a shopper
         ever types into there. Every dismissal path was gated on that test, so
         none of them could ever fire on a phone - which is why the readout
         showed hundreds of touchmoves and scrolls arriving while dismissals
         stayed at zero. Nothing was being suppressed; the guard was rejecting
         its own field.

         The keyboard going away on a tap was iOS doing it natively, not us.

         The rest of the file already knew this - the refocus check pairs the
         element with mobileSearch - so this uses the same idiom rather than
         inventing a second one. */
      this._ownsField = function (el) {
        if (!el) return false;
        if (self.contains(el)) return true;
        return !!(self.mobileSearch && self.mobileSearch.contains(el));
      };

      this._dismissKeyboard = function (event) {
        var active = document.activeElement;
        if (!active || typeof active.blur !== 'function') return;
        if (!self._ownsField(active)) return;
        if (event && event.type === 'click') {
          if (event.target.closest('a, button, input, textarea, select, [role="button"], [role="tab"]')) return;
        }
        active.blur();
        /* Only when movement dismissed it. A tap is left alone deliberately:
           the shopper may have scrolled to something earlier and then tapped to
           put the keyboard away, and yanking them back to the top would throw
           away a position they chose. Movement-driven dismissal is the case
           where the drawer is left holding a mid-gesture offset it was never
           asked for. */
        if (!event || event.type !== 'click') self._pendingScrollReset = true;
      };

      /* THE DOCUMENT SCROLLED. Of everything tried to catch the moment the view
         moves under an open keyboard, this is the one signal never wired up: the
         panel's own scroll fires only when the panel scrolls (and since the
         scroller moved to the drawer, not even then), visualViewport's scroll
         never arrived, and touchmove may never reach us. But when Safari enters
         keyboard mode it scrolls the LAYOUT viewport to keep the input reachable,
         and a layout-viewport scroll is reported on window like any other.

         Threshold, not zero: iOS settles the scroll position by a pixel or two
         when the keyboard animates in, and that must not read as the shopper
         moving the page. Once past it we drop the keyboard, Safari leaves
         keyboard mode, and the lock we already have resumes control - which is
         the whole point. No geometry correction, just end the mode. */
      this._scrollBase = null;
      this._onWindowScroll = function () {
        /* Only while a finger is actually on the glass. See the note on the
           drawer's scroll listener below - the keyboard's own arrival moves
           things with nobody touching the screen. */
        if (!self._gesture) return;
        var y = window.pageYOffset || document.documentElement.scrollTop || 0;
        if (self._scrollBase === null) self._scrollBase = y;
        if (Math.abs(y - self._scrollBase) <= 4) return;
        var active = document.activeElement;
        if (!active || !self._ownsField(active) || typeof active.blur !== 'function') return;
        if (!active.matches('input, textarea')) return;
        active.blur();
        /* Safari restores the viewport as the keyboard goes; --ps-top was read
           from a rect taken mid-pan, so re-seat the panel under the header once
           that has happened rather than leaving the gap behind. */
        window.requestAnimationFrame(function () {
          self.setMobileTop();
        });
      };
      window.addEventListener('scroll', this._onWindowScroll, { passive: true });
      document.addEventListener('scroll', this._onWindowScroll, { passive: true, capture: true });

      this.panel.addEventListener('click', this._dismissKeyboard);
      /* v6 moved the scroller from the panel to the drawer, which left this
         listener on an element that can no longer scroll. Follow the scroller. */
      this._dismissScroller = this.querySelector('.predictive-search__drawer') || this.panel;
      /* A scroll only dismisses when a finger is driving it.

         Without this, refocusing the field could not raise the keyboard: the
         keyboard arrives, the visual viewport shrinks, the drawer's height cap
         shrinks with it, and the reflow moves the scroll position - which the
         scroll listener read as the shopper scrolling and answered by
         dismissing the keyboard that had just opened. The keyboard flashed and
         vanished. The loop only became possible once the dismissal started
         working at all.

         _gesture is set on touchstart and cleared on touchend, so it says
         plainly whether a finger is down. No timers and no grace window: a
         delay would only have raced the same reflow, and the finger is the
         real distinction rather than an approximation of it.

         Desktop consequence, deliberate: scrolling the results with a mouse no
         longer blurs the field. There is no on-screen keyboard to dismiss
         there, which is the only thing this ever existed to do. */
      this._onScrollerScroll = function (event) {
        if (!self._gesture) return;
        self._dismissKeyboard(event);
      };
      this._dismissScroller.addEventListener('scroll', this._onScrollerScroll, { passive: true });

      /* And the same dismissal from the drag itself. Tapping in the drawer
         already hides the keyboard, but scrolling did not, and the scroll event
         above cannot be relied on: the drawer only became scrollable at all in
         the previous build, and on this device scroll-shaped signals have a
         history of not arriving. A finger moving inside the drawer is the plain
         fact underneath both, so it drives the same handler.

         Passive, so the drawer keeps scrolling natively while the keyboard
         goes. The threshold is above tap jitter deliberately: a tap that lands
         on a product link is dismissed by the click path, which exempts links,
         and blurring on a few pixels of wobble would collapse the keyboard
         mid-tap and move the link out from under the finger. */
      this._onDrawerDrag = function (e) {
        var g = self._gesture;
        var t = e.touches && e.touches[0];
        if (!g || !t) return;
        if (Math.abs(t.clientX - g.x) < 8 && Math.abs(t.clientY - g.y) < 8) return;
        self._dismissKeyboard(e);
      };
      this._dismissScroller.addEventListener('touchmove', this._onDrawerDrag, { passive: true });


      if (field) this._dismissField = field;
    }

    untrackKeyboardDismiss() {
      this._pendingScrollReset = false;
      if (!this.panel || !this._dismissKeyboard) return;
      this.panel.removeEventListener('click', this._dismissKeyboard);
      if (this._dismissScroller) {
        this._dismissScroller.removeEventListener('scroll', this._onScrollerScroll, { passive: true });
        this._onScrollerScroll = null;
        if (this._onDrawerDrag) {
          this._dismissScroller.removeEventListener('touchmove', this._onDrawerDrag, { passive: true });
          this._onDrawerDrag = null;
        }
        this._dismissScroller = null;
      }
      if (this._onWindowScroll) {
        window.removeEventListener('scroll', this._onWindowScroll, { passive: true });
        document.removeEventListener('scroll', this._onWindowScroll, { passive: true, capture: true });
        this._onWindowScroll = null;
      }
      this._scrollBase = null;
      this._dismissKeyboard = null;
    }

    trackViewport() {
      var vv = window.visualViewport;
      if (!vv) return; // no support: falls back to the dvh values in the CSS
      var root = document.documentElement;
      var self = this;
      this._onViewport = function () {
        /* A pan can leave the visual viewport offset while the layout viewport
           has not moved. If the keyboard then dismisses, the compensation values
           describe a state that no longer exists and the composition comes back
           in pieces - header detached, panel fragments in the wrong place
           (#830). So when the visible height returns to roughly the full window
           the keyboard has gone: clear the offset outright rather than trusting
           a reading taken mid-pan, and re-measure the header, since --ps-top was
           captured from a rect that was itself panned. */
        /* Height alone cannot tell us the keyboard is up. On iOS the URL bar
           collapses as soon as the page is scrolled, which shrinks the visual
           viewport WITHOUT any keyboard - the two only agree at the very top of
           the page. Treating that as a keyboard fed vv.offsetTop into the panel's
           top offset and skipped the header re-measure, so with the page scrolled
           the panel was pushed away from the header and out of view, and it came
           right again only when scrolled back to the top.
           The keyboard is therefore identified by what actually raises it: focus
           sitting in the search field. Height is still required as well, so a
           focused field with no keyboard (a hardware keyboard, or the moment
           before it animates in) does not offset anything. */
        var active = document.activeElement;
        var typing = active && self.contains(active) && active.matches('input, textarea');
        var shrunk = Math.abs(vv.height - window.innerHeight) > 2;
        var keyboard = shrunk && typing;

        root.style.setProperty('--vv-height', vv.height + 'px');
        /* Kept for the debug readout only - nothing lays out against it now. */
        root.style.setProperty('--vv-offset', keyboard ? vv.offsetTop + 'px' : '0px');
        // Re-measure whenever the keyboard is NOT the thing moving the viewport,
        // which now includes an ordinary scroll: the header condenses as the page
        // moves, so its bottom edge - the panel's anchor - has to be read again.
        if (!keyboard) self.setMobileTop();
        self.resetDrawerScrollIfPending();
      };
      this._onViewport();
      vv.addEventListener('resize', this._onViewport);
      vv.addEventListener('scroll', this._onViewport);
    }

    untrackViewport() {
      var vv = window.visualViewport;
      if (vv && this._onViewport) {
        vv.removeEventListener('resize', this._onViewport);
        vv.removeEventListener('scroll', this._onViewport);
      }
      this._onViewport = null;
      // Cleared rather than left behind, so the fallbacks apply once search is
      // shut and nothing else on the page inherits a stale keyboard height.
      document.documentElement.style.removeProperty('--vv-height');
      document.documentElement.style.removeProperty('--vv-offset');
    }

    unlockScroll() {
      this.untrackKeyboardDismiss();
      this.untrackHeader();
      this.untrackViewport();
      document.documentElement.style.overflow = '';
      this.removeAttribute('data-scroll-locked');
      if (this._onTouchStart) {
        document.removeEventListener('touchstart', this._onTouchStart, { passive: true });
        document.removeEventListener('touchend', this._onTouchEnd, { passive: true });
        document.removeEventListener('touchcancel', this._onTouchEnd, { passive: true });
        this._onTouchStart = null;
        this._onTouchEnd = null;
      }
      this._gesture = null;
      if (this._onTouchMove) {
        document.removeEventListener('touchmove', this._onTouchMove, { passive: false });
        this._onTouchMove = null;
      }
    }

    open() {
      // Re-entrancy guard: returning focus to the field on close fires a focus
      // event; this stops that from re-opening the panel.
      if (this._suppressOpen) return;
      if (this.isOpen) {
        this.syncControls();
        return;
      }
      if (!this.mql.matches) {
        this.setMobileTop();
        this.trackHeader();
        this.trackKeyboardDismiss();
        this.lockScroll();
        // Mobile: the full-screen drawer is a modal dialog so AT treats the
        // obscured page behind it as inert (mirrors the menu-drawer).
        this.panel.setAttribute('role', 'dialog');
        this.panel.setAttribute('aria-modal', 'true');
      }
      this.setAttribute('open', '');
      /* Publish the overlay's presence on <html> so anything pinned to the
         viewport can get out of its way - the Zendesk launcher is the first,
         and it owns its own rule in snippets/zendesk-widget. Same contract the
         sticky add-to-cart and collection filter bars already use: the feature
         raises the flag and is responsible for clearing it again.

         The theme's other overlays are showModal() dialogs, which the browser
         promotes to the top layer, so they cover the launcher whatever its
         z-index and need no flag. This overlay is a plain element toggling an
         open attribute, so nothing stacks it above the launcher for us. */
      document.documentElement.classList.add('search-open');
      var field = this.activeField;
      if (field) field.setAttribute('aria-expanded', 'true');

      /* Constructor: popular searches replace the merchant's trending menu, and the
         beacon wants to know the field was focused. Both are one-per-page. */
      if (this.cnstrcMode) {
        this.primeConstructorSuggestions();
        this.trackConstructor('trackInputFocus', this.currentQuery());
      }

      this.handleQuery();
      this.syncControls();
    }

    /* Fills the idle state from Constructor: popular searches in the suggestion
       slot, and the product-suggestions pod over the theme's featured collection, so
       the drawer shows engine content before a term is typed. Once per page. */
    primeConstructorSuggestions() {
      if (this.cnstrcPrimed) return;
      this.cnstrcPrimed = true;
      this.restoreConstructorSuggestions();
      this.primeConstructorFeatured();
    }

    /* Replaces the server-rendered featured product cards with the pod's, so the
       idle grid is Constructor-driven too. Left alone if the pod is switched off or
       returns nothing, so an unset or unpopulated pod degrades to the merchant's
       featured collection rather than an empty drawer.

       Constructor calls this the zero state, and it is a RECOMMENDATIONS surface, not
       an autosuggest one - the items come from a pod, not from a query. So the
       container takes the recommendations attributes and the cards are recommendation
       items. They keep item-section as well, which the spec asks for on exactly this
       case: a pod powering zero-state autosuggest results. The attributes are set here
       rather than in Liquid so they exist only when the pod really served the cards;
       the merchant's featured collection stays untagged. */
    primeConstructorFeatured() {
      if (!this.products) return;
      var self = this;
      var pod = this.pods.products;
      if (!pod) {
        this.settleFeatured();
        return;
      }
      window.esrConstructor.load().then(function (client) {
        if (!client) return;
        return client.recommendations
          .getRecommendations(pod, {
            numResults: 4,
            section: 'Products'
          })
          .then(function (res) {
            var items = (res && res.response && res.response.results) || [];
            if (!items.length) return;
            /* The pod's items become the theme's standard cards, rendered by Liquid -
               one request each, so this resolves a beat after the pod does. The
               merchant's server-rendered featured collection stays in place until they
               land, and is left alone entirely if none of them render. */
            return window.esrConstructor
              .hydrateAll(items, { section: 'Products', recommendation: true })
              .then(function (rows) {
                if (!rows.length) return;
                self.products.innerHTML = '';
                rows.forEach(function (row) { self.products.appendChild(row.el); });
                window.esrConstructor.initInjectedCards();
                window.esrConstructor.tagRecommendations(self.products, {
                  podId: pod,
                  resultId: res.result_id,
                  // Response total, not the four asked for. Unseeded: the zero state has
                  // no item to work from.
                  numResults: res.response && res.response.total_num_results
                });
                /* The pod can resolve after the shopper has already typed, and the
                   container attributes must not be live outside the zero state.
                   Re-running the current state parks them if so. */
                self.setState(self.getAttribute('data-state') || 'idle');
              });
          });
      })
        .catch(function () {})
        /* Runs on every outcome - cards injected, empty pod, 404, dead SDK - because
           the grid stays invisible until the choice between the pod's cards and the
           merchant's featured collection has actually been made. */
        .then(function () { self.settleFeatured(); });
    }

    /* Reveals the idle grid, fading it in. In Constructor mode the grid starts
       transparent, so the pod replacing the server-rendered featured collection is one
       fade rather than a flash of one set of cards followed by another. Whichever set
       wins, it fades in once - and a pod that answers before the drawer is opened has
       already settled, so there is no fade at all. */
    settleFeatured() {
      if (this.products) this.products.classList.remove('predictive-search__cards--pending');
    }

    restoreConstructorSuggestions() {
      var self = this;
      var token = this.cnstrcToken;

      /* Results are query-scoped, so clear them on the way back to idle. Leaving
         them would keep tagged items in the DOM that the shopper cannot see. */
      if (this.categoriesList) this.categoriesList.innerHTML = '';
      if (this.liveProducts) this.liveProducts.innerHTML = '';
      this.hasCollections = false;
      this.hasProducts = false;

      this.fetchConstructorSuggestions().then(function (suggestions) {
        // A query typed while this was in flight wins.
        if (token !== self.cnstrcToken) return;
        // Pod-served, so these render as recommendation items.
        self.renderSuggestions(suggestions, true);
        self.hasSuggestions = suggestions.length > 0;
        /* The list is the zero state's second recommendations container, alongside the
           product grid. Tagged only when the pod actually returned terms, so an empty
           pod leaves it untagged and the aside falls back to the merchant's menus. */
        if (suggestions.length && self.suggestionsList) {
          window.esrConstructor.tagRecommendations(self.suggestionsList, self.cnstrcSuggestionsMeta || {});
        }
        // The pod resolves after setState has already run, so re-apply visibility.
        self.setState(self.getAttribute('data-state') || 'idle');
      });
    }

    /* Fire-and-forget tracker call. Never allowed to throw into the drawer, and a
       no-op when the SDK is unavailable. */
    trackConstructor(method, term, extra) {
      if (!this.cnstrcMode) return;
      var self = this;
      window.esrConstructor.load().then(function (client) {
        if (!client || !client.tracker || typeof client.tracker[method] !== 'function') return;
        var params = extra || {};
        if (self.cnstrcResultId) params.resultId = self.cnstrcResultId;
        try {
          if (term == null) client.tracker[method](params);
          else client.tracker[method](term, params);
        } catch (e) {}
      }).catch(function () {});
    }

    close() {
      if (!this.isOpen) return;
      // If focus is anywhere within the overlay (panel content or a control that
      // is about to hide), return it to the active field on close (WCAG 2.4.3).
      var active = document.activeElement;
      var refocus = this.contains(active) || (this.mobileSearch && this.mobileSearch.contains(active));

      this.abort();
      this.removeAttribute('open');
      // Cleared here, and only here: every close path - Escape, the backdrop,
      // the mobile dismiss - funnels through this method, and the open
      // attribute is removed in exactly one place, so the flag cannot be
      // stranded by a route that skips it.
      document.documentElement.classList.remove('search-open');
      this.fields.forEach(function (field) {
        field.setAttribute('aria-expanded', 'false');
        // Closing also clears the query. Set the value directly (dispatching an
        // input event would re-open the overlay) and keep each field's own Clear
        // button in sync since we changed the value programmatically.
        field.value = '';
        var wrap = field.closest('[data-search]');
        var clearBtn = wrap ? wrap.querySelector('[data-search-clear]') : null;
        if (clearBtn) clearBtn.hidden = true;
      });
      this.panel.setAttribute('role', 'region');
      this.panel.removeAttribute('aria-modal');
      this.unlockScroll();
      this.closeButtons.forEach(function (btn) {
        btn.hidden = true;
      });
      this.setState('idle');

      if (refocus) {
        var field = this.activeField;
        if (field) {
          if (this.mql.matches) {
            // Desktop: return focus to the field (WCAG 2.4.3); guarded so the
            // focus event doesn't re-open the overlay.
            this._suppressOpen = true;
            field.focus();
            this._suppressOpen = false;
          } else {
            // Mobile: blur to dismiss the keyboard. Refocusing would re-open the
            // overlay (focus opens search) and iOS fires that focus async, so the
            // open guard can't catch it.
            if (active && active.blur) active.blur();
          }
        }
      }
    }

    onInput() {
      if (!this.isOpen) this.open();
      this.syncControls();
      this.handleQuery();
    }

    onKeydown(event) {
      if (event.key === 'Escape' && this.isOpen) this.close();
    }

    onDocumentClick(event) {
      if (!this.isOpen) return;
      if (this.contains(event.target)) return;
      if (this.mobileSearch && this.mobileSearch.contains(event.target)) return;
      this.close();
    }

    onBreakpoint() {
      // The active field + layout change across the breakpoint; close cleanly.
      this.close();
    }

    // Empty field -> idle (static aside + featured). A query debounces a native
    // fetch; the state flips to results / no-results once it resolves, so the
    // idle content stays put (no empty flash) while the request is in flight.
    handleQuery() {
      var query = this.currentQuery();
      if (!query) {
        this.abort();
        /* Constructor: clearing the field drops back to popular searches, replacing
           the query suggestions the last search left in the list. Cached, so this
           costs nothing after the first fetch. */
        if (this.cnstrcMode) {
          this.cnstrcToken++;
          this.restoreConstructorSuggestions();
        }
        this.setState('idle');
        return;
      }
      var self = this;
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(function () {
        self.fetchResults(query);
      }, 250);
    }

    abort() {
      clearTimeout(this.debounceTimer);
      if (this.controller) {
        this.controller.abort();
        this.controller = null;
      }
    }

    /* True when Constructor is enabled and keyed. In that mode Shopify Search &
       Discovery is not consulted at all. */
    get cnstrcMode() {
      return this.hasAttribute('data-cnstrc-search-engine') && !!window.esrConstructor;
    }

    /* Constructor's autocomplete replaces both Shopify requests. Products come from
       the Products section; the suggestion list is a separate recommendations pod
       (Constructor's own "Search Suggestions" autocomplete section is not what powers
       it). The autocomplete failure is swallowed so a Constructor outage leaves the
       drawer empty rather than broken: `res` comes back null, all three sections
       read empty, and the drawer lands on 'no-results' with the popular-searches
       aside. Note the single call means categories now share that fate - but they
       already would have, since a term with no products and no suggestions was
       going to 'no-results' regardless. */
    fetchResultsFromConstructor(query) {
      var self = this;
      var token = ++this.cnstrcToken;

      window.esrConstructor.load().then(function (client) {
        if (!client || token !== self.cnstrcToken) return;

        /* ONE call. Autocomplete now carries the category column too, in a
           `Categories` section Constructor curate in the index, so the second
           request (a one-row `getSearchResults` read only for its group counts) is
           gone - two network calls per keystroke become one.

           ALL THREE sections must be named in `resultsPerSection`. Naming one
           suppresses the rest: asking for Categories alone returns
           `{ Products: 0, 'Search Suggestions': 0, Categories: 5 }` - verified
           against the AU index on 11 Sept 2026. Omitting the option entirely gives
           Constructor's own defaults (3/3/4), which is not what the layout wants. */
        return client.autocomplete
          .getAutocompleteResults(query, {
            resultsPerSection: {
              Products: 4,
              'Search Suggestions': 6,
              Categories: 5
            }
          })
          .catch(function () { return null; })
          .then(function (res) {
            if (token !== self.cnstrcToken) return;
            var sections = (res && res.sections) || {};
            self.cnstrcResultId = (res && res.result_id) || null;
            self.renderConstructorResults(
              query,
              sections.Products || [],
              sections['Search Suggestions'] || [],
              self.constructorCategories(sections.Categories)
            );
          });
      });
    }

    /* Popular searches, fetched once per page and reused. Query-independent, so the
       same list serves the idle and results states. Resolves to an empty list when the
       pod setting is blank - no request is made with an empty id - which lands on the
       same fallback as a 404 or an empty pod: the merchant's Trending / Browse by room
       menus (see setState). */
    fetchConstructorSuggestions() {
      if (this.cnstrcSuggestionsPromise) return this.cnstrcSuggestionsPromise;
      // Column switched off: no pod call, and the aside falls back to the
      // merchant's Trending / Browse by room menus.
      var pod = this.suggestionsEnabled ? this.pods.suggestions : '';
      if (!pod) {
        this.cnstrcSuggestionsPromise = Promise.resolve([]);
        return this.cnstrcSuggestionsPromise;
      }
      var self = this;
      this.cnstrcSuggestionsPromise = window.esrConstructor.load().then(function (client) {
        if (!client) return [];
        /* The section param is required, not optional: the pod lives in the Search
           Suggestions section, and without naming it the request defaults to
           Products and the pod is reported as not found (404). */
        return client.recommendations
          .getRecommendations(pod, {
            numResults: 5,
            section: 'Search Suggestions'
          })
          .then(function (res) {
            var r = (res && res.response && res.response.results) || [];
            /* Pod meta kept for the container attributes - the zero-state suggestion
               list is a recommendations surface just like the product grid, so it
               needs the pod id, result id and response total. Stashed rather than
               returned so the resolved value stays a plain list of suggestions. */
            self.cnstrcSuggestionsMeta = {
              podId: pod,
              resultId: res && res.result_id,
              numResults: res && res.response && res.response.total_num_results
            };
            return r.map(function (item) {
              return {
                text: item.value,
                url: self.searchUrl + '?q=' + encodeURIComponent(item.value),
                // The pod's own id for the term, and the strategy that chose it.
                id: (item.data && item.data.id) || '',
                strategyId: (item.strategy && item.strategy.id) || ''
              };
            });
          })
          .catch(function () { return []; });
      }).catch(function () { return []; });
      return this.cnstrcSuggestionsPromise;
    }

    /* Maps the autocomplete `Categories` section onto the shape the renderer already
       expects. Each entry carries only `value` (the display name) and `data.id`,
       which IS the Shopify collection handle, so no Shopify lookup is needed.

       The old group-tree walk and its roll-up deny-list are gone. TECH LEAD'S CALL,
       11 Sept 2026: the deny-list existed to clean up a group tree we were never
       meant to read - it was rooted at "all" and mixed "All ..." and "Sale - ..."
       merchandising buckets in with real categories. Constructor curate this section
       themselves, so there is nothing to filter and a deny-list here would only
       second-guess their merchandising.

       Also the TECH LEAD'S CALL: the column stays at FIVE even though the index
       holds thirteen for a broad term, to keep the layout exactly as it is.

       THE COUNT is `data.products_count`, which Constructor made displayable on
       this section on 11 Sept 2026. It is the number of LIVE products in that
       collection, NOT the number matching the search term: Dining Chairs reports
       52, and that collection holds 80 products of which exactly 52 are active and
       published (verified against the staging store). Alex knows and chose it.

       It is absent on most stores and that is expected, not an error. As of
       11 Sept 2026 the field is configured on the STAGING index only
       (key_4wMDAVrByXOnS6Iy returns `data` keys id/products_count/url); AU and NZ
       return `data` keys of id alone until Constructor apply the config there. So
       `count` is null far more often than not, and the renderer must treat that as
       the normal case - see the markup below.

       Order is still Constructor's own relevance order. The count is NOT used for
       sorting: the old count sort went with the group tree and does not come back.
       TECH LEAD'S CALL, 11 Sept 2026: a zero is not rendered either. A category
       with no live products should not be in the list at all, and "0" beside a
       collection name reads as a fault rather than as information. */
    constructorCategories(items) {
      return (items || [])
        .map(function (item) {
          var data = (item && item.data) || {};
          /* Only a number, or a non-empty numeric string, is considered - so a
             boolean cannot become "1" via Number(true). Number() rather than
             parseInt because it rejects "52abc" outright instead of silently
             salvaging the "52". Then only a finite value above zero survives:
             null, undefined, '', NaN, Infinity, negatives and 0 all render
             nothing. */
          var raw = data.products_count;
          var count = null;
          if (typeof raw === 'number' || (typeof raw === 'string' && raw !== '')) {
            var n = Number(raw);
            if (isFinite(n) && n > 0) count = Math.round(n);
          }
          return {
            group_id: data.id || '',
            display_name: (item && item.value) || '',
            count: count
          };
        })
        .filter(function (g) { return g.group_id && g.display_name; });
    }

    renderConstructorResults(query, items, suggestionItems, categories) {
      var self = this;

      /* Products are the theme's standard card, rendered by Liquid a request at a time,
         so they land a beat after the aside and the categories. Two consequences worth
         knowing:

         - The previous term's cards are left in place until the new ones are ready,
           rather than the grid emptying on every keystroke. `aria-busy` says so while
           it is in flight.
         - The token guard is the one fetchResultsFromConstructor uses: a fast typist
           outruns a hydration, and a stale term's cards must never land in the grid. */
      var token = this.cnstrcToken;
      if (this.liveProducts) {
        if (items.length) {
          this.liveProducts.setAttribute('aria-busy', 'true');
          window.esrConstructor.hydrateAll(items, { section: 'Products' }).then(function (rows) {
            if (token !== self.cnstrcToken || !self.liveProducts) return;
            self.liveProducts.innerHTML = '';
            rows.forEach(function (row) { self.liveProducts.appendChild(row.el); });
            self.liveProducts.removeAttribute('aria-busy');
            window.esrConstructor.initInjectedCards();
          });
        } else {
          this.liveProducts.innerHTML = '';
          this.liveProducts.removeAttribute('aria-busy');
        }
      }
      if (this.viewAll) this.viewAll.href = this.searchUrl + '?q=' + encodeURIComponent(query) + '&type=product';

      /* Query suggestions come from the autocomplete response while the shopper is
         typing; the popular-searches pod only backs the idle state. */
      var suggestions = (suggestionItems || []).map(function (item) {
        return {
          text: item.value,
          url: self.searchUrl + '?q=' + encodeURIComponent(item.value),
          /* Constructor's own id for the term. Carried through so the <li> can
             tag it (Constructor request, 2026-08-11) - the mapping previously
             kept only the label and the id never reached the renderer. */
          id: (item.data && item.data.id) || ''
        };
      });
      /* Categories. Label, plus a product count when Constructor return one. The
         Liquid path renders the same span from `collection.all_products_count`
         (sections/predictive-search-results.liquid), so both paths share one set
         of CSS rules and look identical. */
      var cats = categories || [];
      if (this.categoriesList) {
        var esc = function (s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); };
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var base = root.replace(/\/$/, '') + '/collections/';
        this.categoriesList.innerHTML = cats.map(function (g) {
          return '<li data-cnstrc-item-section="Categories" data-cnstrc-item-id="' + esc(g.group_id) + '"' +
            ' data-cnstrc-item-name="' + esc(g.display_name) + '">' +
            '<a class="predictive-search__result-link" href="' + base + encodeURIComponent(g.group_id) + '">' +
            '<span class="predictive-search__result-label">' + esc(g.display_name) + '</span>' +
            /* Count only when the mapper resolved a real number. On a store where
               Constructor have not configured products_count - AU and NZ today -
               this contributes NOTHING: no span, no dash, no zero, no placeholder,
               so the column reads as deliberate rather than broken. Same span and
               class as the native Shopify path renders from
               sections/predictive-search-results.liquid, so the styling is shared
               and nothing new is needed. */
            (g.count === null ? '' :
              '<span class="predictive-search__result-count">' + esc(g.count) + '</span>') +
            '</a></li>';
        }).join('');
      }

      this.hasProducts = items.length > 0;
      this.hasSuggestions = suggestions.length > 0;
      this.hasCollections = cats.length > 0;

      if (this.hasProducts || this.hasSuggestions || this.hasCollections) {
        this.setState('results');
        /* AFTER setState, not before. renderSuggestions decides whether to tag an
           item by reading data-cnstrc-autosuggest off the panel, and setState is
           what un-parks that attribute. Rendering first meant the panel was still
           in the previous state, so every suggestion went out untagged while
           Categories - whose attributes are unconditional - looked fine. */
        this.renderSuggestions(suggestions);
      } else {
        /* Nothing matched, so the aside goes back to popular searches - the query
           suggestions it was holding are no use against a term with no results. */
        this.setState('no-results');
        this.restoreConstructorSuggestions();
      }
    }

    fetchResults(query) {
      if (this.cnstrcMode) {
        this.abort();
        this.fetchResultsFromConstructor(query);
        return;
      }
      if (!('AbortController' in window) || typeof fetch !== 'function') return;
      this.abort();
      this.controller = new AbortController();
      var signal = this.controller.signal;
      var self = this;
      var q = encodeURIComponent(query);

      // Query suggestions come only from the JSON endpoint (the predictive_search
      // Liquid object has no queries); Search and Discovery powers this list. With
      // the suggestions column switched off there is nowhere to put them, so the
      // request is skipped rather than made and discarded.
      var queriesReq = Promise.resolve(null);
      if (this.suggestionsEnabled) {
        queriesReq = fetch(this.suggestUrl + '.json?q=' + q + '&resources[type]=query&resources[limit]=6', { signal: signal })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      }

      // Rich collections (with counts) + product cards render server-side via the
      // Section Rendering API so the product-card snippet is reused verbatim.
      var sectionReq = Promise.resolve('');
      if (this.resultsSection) {
        sectionReq = fetch(this.suggestUrl + '?q=' + q + '&section_id=' + encodeURIComponent(this.resultsSection) + '&resources[type]=product,collection&resources[limit]=10&resources[limit_scope]=each', { signal: signal })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .catch(function () { return ''; });
      }

      Promise.all([queriesReq, sectionReq]).then(function (res) {
        if (signal.aborted) return;
        self.renderResults(query, res[0], res[1]);
      });
    }

    renderResults(query, queriesJson, sectionHtml) {
      var suggestions = [];
      if (queriesJson && queriesJson.resources && queriesJson.resources.results) {
        suggestions = queriesJson.resources.results.queries || [];
      }
      this.renderSuggestions(suggestions);

      var collectionsHtml = '';
      var productsHtml = '';
      if (sectionHtml) {
        var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
        var col = doc.querySelector('[data-ps-collections-list]');
        var prod = doc.querySelector('[data-ps-products-list]');
        collectionsHtml = col ? col.innerHTML.trim() : '';
        productsHtml = prod ? prod.innerHTML.trim() : '';
      }
      if (this.categoriesList) this.categoriesList.innerHTML = collectionsHtml;
      if (this.liveProducts) this.liveProducts.innerHTML = productsHtml;

      if (this.viewAll) {
        this.viewAll.href = this.searchUrl + '?q=' + encodeURIComponent(query) + '&type=product';
      }

      // A live group with no items (common: S&D has no query suggestions yet) is
      // hidden in the results state so no empty heading/tab shows.
      this.hasSuggestions = suggestions.length > 0;
      this.hasCollections = collectionsHtml.length > 0;
      this.hasProducts = productsHtml.length > 0;

      // Results whenever there's anything to show. When products are empty but
      // the aside has suggestions/collections, we STAY in the results state and
      // the main panel shows "No products for X" (not the full "No results").
      this.setState((this.hasProducts || this.hasSuggestions || this.hasCollections) ? 'results' : 'no-results');
    }

    /* @param {boolean} [recommendation] - True when the list came from the
       popular-searches pod (the zero state) rather than from autocomplete. */
    renderSuggestions(list, recommendation) {
      if (!this.suggestionsList) return;
      /* The panel is the autosuggest container, and it is a DESCENDANT of this
         element - this.closest never matched it, so query suggestions were going out
         untagged entirely. Read it off the panel instead, and honour the parking: the
         attribute is only present while autosuggest is the live surface. */
      var tagged = !!this.panel && this.panel.hasAttribute('data-cnstrc-autosuggest');
      var html = '';
      list.forEach(function (item) {
        // styled_text is trusted first-party HTML (bolds the matched term).
        var text = item.styled_text || item.text || '';
        var url = item.url || '#';
        var name = (item.text || '').replace(/"/g, '&quot;');
        var attrs = '';
        if (recommendation) {
          /* Zero state: pod-served, so the full recommendation item contract. Section
             is "Search Suggestions" rather than "Products" - it names the pod's own
             section, which is what Constructor joins the event back to. No price or
             variation id: a term is not a purchasable item and the row has no CTA. */
          attrs = ' data-cnstrc-item="recommendation" data-cnstrc-item-section="Search Suggestions"' +
            ' data-cnstrc-item-name="' + name + '"';
          if (item.id) attrs += ' data-cnstrc-item-id="' + String(item.id).replace(/"/g, '&quot;') + '"';
          if (item.strategyId) attrs += ' data-cnstrc-strategy-id="' + String(item.strategyId).replace(/"/g, '&quot;') + '"';
        } else if (tagged) {
          /* Typing: these are autocomplete items. The name is the plain query text,
             not the styled markup. The id is included when the response carries one
             (Constructor request, 2026-08-11 - it was previously omitted on their
             earlier guidance). Native Shopify suggestions have no id, so the
             attribute is simply left off there rather than emitted empty. */
          attrs = ' data-cnstrc-item-section="Search Suggestions" data-cnstrc-item-name="' + name + '"';
          if (item.id) attrs += ' data-cnstrc-item-id="' + String(item.id).replace(/"/g, '&quot;') + '"';
        }
        html += '<li' + attrs + '><a class="predictive-search__result-link" href="' + url + '"><span class="predictive-search__result-label">' + text + '</span></a></li>';
      });
      this.suggestionsList.innerHTML = html;
    }

    // idle: static aside + featured. results: live aside + product cards.
    // no-results: static aside + message + category cards. data-state drives
    // the mobile layout; the [hidden] toggles drive the desktop swaps.
    /* Moves data-cnstrc-item-section to/from a parked attribute name so hidden
       cards stop counting as autocomplete items without losing which section they
       belong to. Reversible, and a no-op once already in the requested state. */
    parkCnstrcSections(scope, park) {
      var from = park ? 'data-cnstrc-item-section' : 'data-cnstrc-item-section-parked';
      var to = park ? 'data-cnstrc-item-section-parked' : 'data-cnstrc-item-section';
      var nodes = scope.querySelectorAll('[' + from + ']');
      for (var i = 0; i < nodes.length; i++) {
        nodes[i].setAttribute(to, nodes[i].getAttribute(from));
        nodes[i].removeAttribute(from);
      }
    }

    /* Same idea, for container attributes on a single element: rename them out of the
       way and back rather than rebuilding the panel.

       Constructor's container types must not nest. The zero state is a recommendations
       container that lives inside the panel, which is the autosuggest container, so
       whichever one is not the current surface has to be parked or an item resolves to
       two containers at once. Parking survives a swap in both directions because the
       value is carried across, so a parked result id is still there when the shopper
       clears the field and returns to the zero state. */
    parkCnstrcAttrs(el, park, names) {
      if (!el || !names) return;
      names.forEach(function (name) {
        var from = park ? name : name + '-parked';
        var to = park ? name + '-parked' : name;
        if (!el.hasAttribute(from)) return;
        el.setAttribute(to, el.getAttribute(from));
        el.removeAttribute(from);
      });
    }

    setState(state) {
      this.setAttribute('data-state', state);
      var isIdle = state === 'idle';
      var isResults = state === 'results';
      var isNoResults = state === 'no-results';
      var query = this.currentQuery();

      // In the results state, the main panel shows product cards when there are
      // any, otherwise the "No products for X" message (the aside still shows
      // its live suggestions/collections).
      var showProducts = isResults && this.hasProducts;
      var showNoProducts = isResults && !this.hasProducts;

      if (this.idleTitle) this.idleTitle.hidden = !isIdle;
      if (this.products) this.products.hidden = !isIdle;

      /* Constructor: a card is only an autocomplete item while its container is the
         one on screen. Both product containers stay in the DOM across states, so the
         hidden one has its section attribute parked - otherwise the beacon reports
         the idle featured products alongside the live results and double counts. */
      if (this.products) this.parkCnstrcSections(this.products, !isIdle);
      if (this.liveProducts) this.parkCnstrcSections(this.liveProducts, !showProducts);

      /* Swap which Constructor container is live, in place - the shopper typing must
         not cost a rebuild of the panel. Exactly one type is live at a time, because
         the recommendations containers sit INSIDE the autosuggest one and nesting them
         makes an item's surface ambiguous.

         Autosuggest is live only in the results state. Idle is the zero state, and
         no-results is not an autosuggest surface either: its product grid is hidden,
         its category list is cleared, and its aside is back on the popular-searches
         pod, so nothing in the panel is an autocomplete item.

         Two recommendations containers, with different lifetimes: the product grid is
         idle-only (it is hidden outside idle), while the suggestion list holds pod
         terms in both idle and no-results. */
      if (this.cnstrcMode) {
        this.parkCnstrcAttrs(this.panel, !isResults, ['data-cnstrc-autosuggest']);
        this.parkCnstrcAttrs(this.products, !isIdle, window.esrConstructor.recommendationAttrs);
        this.parkCnstrcAttrs(this.suggestionsList, isResults, window.esrConstructor.recommendationAttrs);
      }
      // The heading wrapper only holds the idle title + the no-results/no-products
      // message; when products are showing it is empty, so collapse it (otherwise
      // the main panel's gap adds phantom space above "Product results").
      if (this.heading) this.heading.hidden = showProducts;
      if (this.resultsBar) this.resultsBar.hidden = !showProducts;
      if (this.liveProducts) this.liveProducts.hidden = !showProducts;
      // The message block covers both "no products" (partial) and full "no results".
      if (this.noResults) this.noResults.hidden = !(isNoResults || showNoProducts);
      // Merchant category cards are the fallback for both the "no products"
      // (partial) and the full "no results" states.
      if (this.categories) this.categories.hidden = !(isNoResults || showNoProducts);

      // Aside: static content (Trending / Browse by Room + tab labels) shows in
      // idle + no-results; live content (Suggestions / Categories) in results.
      this.staticEls.forEach(function (el) { el.hidden = isResults; });
      this.liveEls.forEach(function (el) { el.hidden = !isResults; });


      // In the results state, collapse a live group (+ its mobile tab) when it
      // has no items; the aside divider only shows when both live groups do.
      var hideSuggestions = isResults && !this.hasSuggestions;
      var hideCollections = isResults && !this.hasCollections;
      if (this.suggestionsGroup) this.suggestionsGroup.hidden = hideSuggestions;
      if (this.categoriesGroup) this.categoriesGroup.hidden = hideCollections;
      if (this.suggestionsTab) this.suggestionsTab.hidden = hideSuggestions;
      if (this.categoriesTab) this.categoriesTab.hidden = hideCollections;
      if (this.asideDivider) this.asideDivider.hidden = hideSuggestions || hideCollections;

      /* Constructor mode, ONE rule for every state: the engine takes the aside when it
         has something to put there, and otherwise the merchant's Trending and Browse by
         room menus show with their own headings. The aside itself is always visible.

         With engine content: Suggestions is the popular-searches pod in idle, and the
         query suggestions from autocomplete in the results state. Categories only exist
         against a query, so that column shows in the results state only. Suggestions is
         the floor between the two, so a live aside is never a blank panel.

         Both branches set the static/live split EXPLICITLY rather than deferring to the
         Shopify-path rules above. Those hide static content whenever there is a query
         (hidden = isResults), which is right for the Shopify path - its live lists have
         content - but under Constructor it produced a completely empty aside on any query
         the engine answered with neither categories nor suggestions. Verified against the
         index: "l" returns one group, "li" returns zero, and "li" was the blank one.

         hasSuggestions and hasCollections are both false until a response arrives, so the
         static menus also fill the in-flight window rather than an empty column - the
         trap that seeding hasSuggestions true originally caused.

         Runs last so it overrides the Shopify-path rules above. */
      if (this.cnstrcMode) {
        /* "Has engine content" means content AND a column to render it in. Each live
           column lives inside its merchant menu's if-block in the Liquid, so a merchant who
           set no Browse by room menu has no Categories column at all - and counting the
           engine's groups as content when there is nowhere to put them blanked the aside
           just as surely as the bug above. */
        var liveSuggestions = !!this.hasSuggestions && !!this.suggestionsGroup;
        var liveCategories = isResults && !!this.hasCollections && !!this.categoriesGroup;
        var engineAside = liveSuggestions || liveCategories;

        this.staticEls.forEach(function (el) { el.hidden = engineAside; });
        this.liveEls.forEach(function (el) { el.hidden = !engineAside; });

        var showSuggestions;
        var showCategories;
        if (engineAside) {
          showCategories = liveCategories;
          // Suggestions is the floor between the two columns.
          showSuggestions = liveSuggestions || !liveCategories;
        } else {
          /* Merchant menus: show every column the merchant actually configured, the way
             the Shopify path shows them in idle. A null group means its menu is unset,
             so there was nothing to show in that column anyway. */
          showSuggestions = !!this.suggestionsGroup;
          showCategories = !!this.categoriesGroup;
        }

        if (this.suggestionsGroup) this.suggestionsGroup.hidden = !showSuggestions;
        if (this.categoriesGroup) this.categoriesGroup.hidden = !showCategories;
        if (this.suggestionsTab) this.suggestionsTab.hidden = !showSuggestions;
        if (this.categoriesTab) this.categoriesTab.hidden = !showCategories;
        if (this.asideDivider) this.asideDivider.hidden = !(showSuggestions && showCategories);
        if (this.aside) this.aside.hidden = false;
      }

      // If the active mobile tab was just hidden, fall back to the other one.
      if (isResults) this.ensureVisibleTab();

      if (this.noResultsTitle) {
        if (showNoProducts) {
          this.noResultsTitle.textContent = this.noProductsLabel.replace('[query]', query);
        } else if (isNoResults) {
          this.noResultsTitle.textContent = this.noResultsLabel.replace('[query]', query);
        }
      }
      // Announce result changes to screen readers.
      if (this.status) {
        if (showNoProducts) {
          this.status.textContent = this.noProductsLabel.replace('[query]', query);
        } else if (isNoResults) {
          this.status.textContent = this.noResultsLabel.replace('[query]', query);
        } else if (isResults) {
          this.status.textContent = query;
        } else {
          this.status.textContent = '';
        }
      }
      this.syncVideo();
    }

    // Category videos only play when the cards are actually on screen: drawer
    // open, the category cards not hidden, and desktop (the cards are
    // display:none on mobile). Otherwise pause them so nothing plays behind a
    // hidden panel.
    syncVideo() {
      if (!this.categoryVideos.length) return;
      var visible = this.isOpen && this.mql.matches && !!this.categories && !this.categories.hidden;
      this.categoryVideos.forEach(function (video) {
        if (visible) {
          var played = video.play();
          if (played && played.catch) played.catch(function () {});
        } else {
          video.pause();
        }
      });
    }

    // The close button stays available the whole time the overlay is open, so a
    // single click always closes it (and clears the field) regardless of input.
    // The field's own Clear button handles clearing without closing.
    syncControls() {
      this.closeButtons.forEach(function (btn) {
        btn.hidden = true;
      });
      var btn = this.activeCloseBtn;
      if (!btn) return;
      btn.hidden = !this.isOpen;
    }
  }

  if (!customElements.get('predictive-search')) {
    customElements.define('predictive-search', PredictiveSearch);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["price"] && !Shopify.designMode) return;
  try {
    (function () {
    function closeAll() {
      document.querySelectorAll('.price__promo-info.is-open').forEach(function (info) {
        info.classList.remove('is-open');
        var t = info.querySelector('.price__promo-toggle');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }

    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('.price__promo-toggle');
      if (toggle) {
        var info = toggle.closest('.price__promo-info');
        var isOpen = info.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        return;
      }
      // A click inside the tooltip (e.g. the link) leaves it open; anywhere
      // else on the page closes any open tooltip.
      if (e.target.closest('.price__promo-info')) return;
      closeAll();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__esProductCardQuickAdd) return;
    window.__esProductCardQuickAdd = true;

    // --- Image carousel (seamless loop via cloned first/last slides) ---
    // Track layout once set up: [clone(last), real0 .. real(n-1), clone(first)].
    // Position 0 = leading clone, 1..n = real slides, n+1 = trailing clone.
    // A wrap is a single step onto a clone, then an invisible snap to the
    // matching real slide on transitionend.
    function carouselReal(track) {
      return track.querySelectorAll('.product-card__slide:not(.product-card__slide--clone)');
    }

    // Set the track position; when instant, the transform transition is briefly
    // disabled so the move is not animated (used for setup, snaps and resets).
    function carouselSet(track, pos, instant) {
      if (instant) {
        track.style.transition = 'none';
      }
      track.style.setProperty('--carousel-index', String(pos));
      track.dataset.pos = String(pos);
      if (instant) {
        void track.offsetWidth;
        track.style.transition = '';
      }
    }

    // Clone the first/last real slides and park on the first real slide.
    function carouselSetup(track) {
      var clones = track.querySelectorAll('.product-card__slide--clone');
      for (var i = 0; i < clones.length; i++) clones[i].remove();

      var slides = carouselReal(track);
      var count = slides.length;
      track.dataset.count = String(count);
      if (count <= 1) {
        carouselSet(track, 0, true);
        return count;
      }
      var firstClone = slides[0].cloneNode(true);
      var lastClone = slides[count - 1].cloneNode(true);
      firstClone.classList.add('product-card__slide--clone');
      lastClone.classList.add('product-card__slide--clone');
      track.insertBefore(lastClone, slides[0]);
      track.appendChild(firstClone);
      carouselSet(track, 1, true);
      return count;
    }

    // The pristine (no-clone) slide markup, used to cache/restore on swatch swap.
    function carouselPristine(track) {
      var slides = carouselReal(track);
      var html = '';
      for (var i = 0; i < slides.length; i++) html += slides[i].outerHTML;
      return html;
    }

    /* #1110: Shopify answers a refused add with 422 and a body that names the
       product. Reading response.json() without checking response.ok made that
       indistinguishable from success - cart:updated fired, the drawer found
       nothing new, and the shopper was told nothing. */
    function qaMessage(body) {
      if (body && typeof body === 'object') {
        if (body.description) return String(body.description);
        if (body.message) return String(body.message);
      }
      return '';
    }
    var QA_FALLBACK = 'Sorry, this could not be added to your cart. Please try again.';
    function qaShowError(form, text) {
      var box = form.querySelector('[data-cart-add-error]');
      if (!box) return;
      box.textContent = text || '';
      box.hidden = !text;
    }

    document.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-quick-add]');
      if (!form) return;
      event.preventDefault();

      // The form holds both the desktop full-width button and the mobile icon
      // button; mark both busy so whichever is visible reflects the state.
      var buttons = form.querySelectorAll('button');
      for (var bi = 0; bi < buttons.length; bi++) {
        buttons[bi].setAttribute('aria-busy', 'true');
        buttons[bi].disabled = true;
      }

      qaShowError(form, '');

      fetch(form.action, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (response) {
          return response.json().then(function (body) {
            return { ok: response.ok, body: body };
          });
        })
        .then(function (res) {
          if (!res.ok) {
            qaShowError(form, qaMessage(res.body) || QA_FALLBACK);
            return;
          }
          document.dispatchEvent(
            new CustomEvent('cart:updated', { bubbles: true, detail: { item: res.body } })
          );
        })
        .catch(function () { qaShowError(form, QA_FALLBACK); })
        .finally(function () {
          for (var bj = 0; bj < buttons.length; bj++) {
            buttons[bj].removeAttribute('aria-busy');
            buttons[bj].disabled = false;
          }
        });
    });

    document.addEventListener('click', function (event) {
      var swatch = event.target.closest('[data-swatch-image]');
      if (!swatch) return;

      var image = swatch.getAttribute('data-swatch-image');
      if (!image) return;

      var card = swatch.closest('.product-card');
      if (!card) return;

      event.preventDefault();

      var srcset = swatch.getAttribute('data-swatch-srcset');

      // Keep the styled (lifestyle) image in sync with the chosen colour. The
      // collection "Styled" toggle (applyStyled in collection.liquid) reads the
      // card root's data-styled-image, so mirror this colour's styled image onto
      // it - otherwise the toggle would show the card's original colour.
      var styledImage = swatch.getAttribute('data-swatch-styled-image');
      var styledSrcset = swatch.getAttribute('data-swatch-styled-srcset');
      if (styledImage) {
        card.setAttribute('data-styled-image', styledImage);
        if (styledSrcset) {
          card.setAttribute('data-styled-srcset', styledSrcset);
        } else {
          card.removeAttribute('data-styled-srcset');
        }
      } else {
        card.removeAttribute('data-styled-image');
        card.removeAttribute('data-styled-srcset');
      }

      // Is the grid currently showing styled imagery? (data-styled="true" lives
      // on the collection custom element wrapping the cards.)
      var styledOn = !!card.closest('[data-styled="true"]') && !!styledImage;

      var primary = card.querySelector('.product-card__image--primary');
      if (primary) {
        // Refresh the cached "standard" image so toggling Styled off restores
        // the selected colour, not the original.
        primary.dataset.standardSrc = image;
        primary.dataset.standardSrcset = srcset || '';
        if (styledOn) {
          primary.src = styledImage;
          if (styledSrcset) {
            primary.srcset = styledSrcset;
          } else {
            primary.removeAttribute('srcset');
          }
        } else {
          primary.src = image;
          if (srcset) {
            primary.srcset = srcset;
          } else {
            primary.removeAttribute('srcset');
          }
        }
      }

      // Carousel -> the selected product's images (hover image first). The
      // track HTML is swapped below from the swatch fragment; here we just keep
      // a reference and reset to the first slide.

      var selected = card.querySelector('.product-card__swatch--selected');
      if (selected) {
        selected.classList.remove('product-card__swatch--selected');
      }
      swatch.classList.add('product-card__swatch--selected');

      var link = card.querySelector('.product-card__link');
      var url = swatch.getAttribute('href');
      if (link) {
        if (url) {
          link.setAttribute('href', url);
        }
        var title = swatch.getAttribute('data-product-title');
        if (title) {
          link.textContent = title;
        }
      }

      // Re-bind theWishlist heart to the selected colour product so adding to
      // wishlist targets the shown product. The matching ProductJson-{id} /
      // OptionJson-{id} blocks are emitted per visible swatch above.
      var wishlist = card.querySelector('.btn-wishlist');
      var productId = swatch.getAttribute('data-product-id');
      if (wishlist && productId) {
        wishlist.className = wishlist.className.replace(/\bbutton-\d+\b/, 'button-' + productId);
        wishlist.setAttribute('data-product-id', productId);
        wishlist.setAttribute('data-product-title', swatch.getAttribute('data-product-title') || '');
        wishlist.setAttribute('data-has-only-variant', swatch.getAttribute('data-has-only-variant') || 'true');

        // Rewriting the attributes alone is not enough: the app captures the
        // product id in its click listener's closure at bind time, so the heart
        // would keep adding the ORIGINAL colour (task #19044869). Fire the
        // app's own re-bind hook, scoped to this card - it re-reads the updated
        // attributes and re-binds a fresh clone of the button. Harmless when
        // the app hasn't initialised yet (no listener; its later init reads the
        // updated attributes anyway).
        document.body.dispatchEvent(new CustomEvent('wishlist:refresh', {
          detail: { scope: { container: card } }
        }));

        // The re-bind REPLACED the button node (the app clones it to drop the
        // stale listener), so re-query it, then sync the filled-heart state to
        // the selected product - the .is-wishlisted class otherwise carries
        // over from the previous colour. Same check as twc-scripts.liquid.
        wishlist = card.querySelector('.btn-wishlist');
        if (wishlist && typeof theWishlist !== 'undefined' && typeof theWishlist.checkVariantInWishlist === 'function') {
          var wishlisted = false;
          var productJson = document.getElementById('ProductJson-' + productId);
          if (productJson) {
            try {
              var wlVariants = (JSON.parse(productJson.textContent) || {}).variants || [];
              for (var wv = 0; wv < wlVariants.length; wv++) {
                if (theWishlist.checkVariantInWishlist(wlVariants[wv].id)) {
                  wishlisted = true;
                  break;
                }
              }
            } catch (wlErr) {}
          }
          wishlist.classList.toggle('is-wishlisted', wishlisted);
        }
      }

      // Point quick-add at the selected colour product.
      var variantId = swatch.getAttribute('data-variant-id');
      var quickAddForm = card.querySelector('[data-quick-add] input[name="id"]');
      if (quickAddForm && variantId) {
        quickAddForm.value = variantId;
      }
      var moreOptions = card.querySelectorAll('.product-card__quick-add a[href]');
      for (var moi = 0; moi < moreOptions.length; moi++) {
        if (url) moreOptions[moi].setAttribute('href', url);
      }

      // Keep Constructor's item attributes on the selected colour. A swatch swaps the
      // card to a different PRODUCT, so the item id, the variation and the price all
      // move together. Absent when Constructor is off, in which case there is nothing
      // to update.
      //
      // The id is the sibling's variant SKU, matching what `constructor-item-attrs`
      // renders and what the feed is keyed on - BOTH item id and variation id are the
      // SKU there. This used to write the handle and the Shopify variant id, from when
      // the index was keyed on handle: after the re-key, a click on a swapped card
      // reported an item id that joined to nothing.
      var cnstrcHandle = swatch.getAttribute('data-cnstrc-handle');
      var cnstrcSku = swatch.getAttribute('data-cnstrc-sku');
      if (cnstrcHandle && card.hasAttribute('data-cnstrc-item-id')) {
        var cnstrcId = cnstrcSku || cnstrcHandle;
        card.setAttribute('data-cnstrc-item-id', cnstrcId);
        var cnstrcTitle = swatch.getAttribute('data-product-title');
        if (cnstrcTitle) card.setAttribute('data-cnstrc-item-name', cnstrcTitle);
        card.setAttribute('data-cnstrc-item-variation-id', cnstrcId);
        var cnstrcPrice = swatch.getAttribute('data-cnstrc-price');
        if (cnstrcPrice) card.setAttribute('data-cnstrc-item-price', cnstrcPrice);
      }

      // Swap badge, price and rating to the selected colour. Siblings carry a
      // server-rendered <template> fragment; the current swatch has none, so we
      // cache the card's original (already-rendered) badge/price/rating once and
      // restore from that - avoids duplicating the current product's fragment.
      var badgeNode = card.querySelector('.product-card__badge');
      var priceNode = card.querySelector('.price');
      var metaNode = card.querySelector('.product-card__meta');
      var ratingNode = metaNode ? metaNode.querySelector('.rating') : null;
      var trackNode = card.querySelector('.product-card__carousel-track');

      if (!card.__esOriginalFragments) {
        card.__esOriginalFragments = {
          badge: badgeNode ? badgeNode.innerHTML : '',
          price: priceNode ? priceNode.outerHTML : null,
          rating: ratingNode ? ratingNode.outerHTML : '',
          carousel: trackNode ? carouselPristine(trackNode) : null
        };
      }

      var li = swatch.closest('li');
      var fragments = li ? li.querySelector('template[data-swatch-fragments]') : null;
      var badgeHTML, priceHTML, ratingHTML, carouselHTML;
      if (fragments) {
        var content = fragments.content;
        var bf = content.querySelector('[data-fragment="badge"]');
        var pf = content.querySelector('[data-fragment="price"]');
        var rf = content.querySelector('[data-fragment="rating"]');
        var cf = content.querySelector('[data-fragment="carousel"]');
        badgeHTML = bf ? bf.innerHTML : '';
        priceHTML = pf ? pf.innerHTML : null;
        ratingHTML = rf ? rf.innerHTML.trim() : '';
        carouselHTML = cf ? cf.innerHTML : null;
      } else {
        badgeHTML = card.__esOriginalFragments.badge;
        priceHTML = card.__esOriginalFragments.price;
        ratingHTML = card.__esOriginalFragments.rating;
        carouselHTML = card.__esOriginalFragments.carousel;
      }

      // Rebuild the carousel from the selected product's slides, clear the loop
      // setup (clones/position re-init lazily on the next arrow click), reset to
      // the first slide (its hover image), and show arrows only if >1 slide.
      if (trackNode && carouselHTML != null) {
        trackNode.innerHTML = carouselHTML;
        carouselSet(trackNode, 0, true);
        trackNode.scrollLeft = 0;
        delete trackNode.dataset.pos;
        delete trackNode.dataset.count;
        var navNode = card.querySelector('.product-card__nav');
        if (navNode) {
          navNode.hidden = trackNode.querySelectorAll('.product-card__slide').length <= 1;
        }
      }

      if (badgeNode) {
        badgeNode.innerHTML = badgeHTML;
      }
      if (priceNode && priceHTML != null) {
        priceNode.outerHTML = priceHTML;
      }
      if (metaNode) {
        if (ratingNode) {
          if (ratingHTML) {
            ratingNode.outerHTML = ratingHTML;
          } else {
            ratingNode.remove();
          }
        } else if (ratingHTML) {
          metaNode.insertAdjacentHTML('beforeend', ratingHTML);
        }
      }

      // Same focus release as the arrows: a mouse click leaves the swatch link
      // focused, so :focus-within would keep the hover overlay visible after
      // the pointer leaves. Keep focus for keyboard activation (detail 0).
      if (event.detail !== 0) {
        swatch.blur();
      }
    });

    // Carousel arrows: step one slide; clones make the wrap seamless.
    document.addEventListener('click', function (event) {
      var arrow = event.target.closest('[data-carousel-prev], [data-carousel-next]');
      if (!arrow) return;
      event.preventDefault();

      var media = arrow.closest('.product-card__media');
      var track = media ? media.querySelector('.product-card__carousel-track') : null;
      if (!track) return;

      // Lazily clone the slides the first time this carousel is used (and after
      // a swatch swap, which clears the setup so it re-runs here).
      var count;
      if (track.dataset.pos === undefined || track.dataset.count === undefined) {
        count = carouselSetup(track);
      } else {
        count = parseInt(track.dataset.count, 10);
      }
      if (count <= 1) return;

      var step = arrow.hasAttribute('data-carousel-next') ? 1 : -1;
      var pos = parseInt(track.dataset.pos, 10);

      // If we're parked on a clone (a wrap whose transitionend snap hasn't run
      // yet - e.g. rapid clicks interrupt the transition), jump instantly to its
      // real twin before stepping. This keeps pos within [0, count + 1] no
      // matter how fast the arrows are clicked, so the track never scrolls off
      // into blank space.
      if (pos >= count + 1) {
        carouselSet(track, 1, true);
        pos = 1;
      } else if (pos <= 0) {
        carouselSet(track, count, true);
        pos = count;
      }

      carouselSet(track, pos + step, false);

      // A mouse click leaves the arrow focused, so :focus-within would keep the
      // overlay (carousel + arrows) visible after the pointer leaves. Drop focus
      // for pointer-driven clicks (event.detail > 0) but keep it for keyboard
      // activation (detail 0) so tab users still see the arrows.
      if (event.detail !== 0) {
        arrow.blur();
      }
    });

    document.addEventListener('transitionend', function (event) {
      var target = event.target;
      if (!target.classList) return;

      // Overlay finished fading out -> reset to the first real slide, invisibly.
      // Resetting on mouseleave instead animated the slides back while the
      // overlay was still visible, which looked wrong.
      if (target.classList.contains('product-card__carousel') && event.propertyName === 'opacity') {
        if (getComputedStyle(target).opacity !== '0') return;
        var t = target.querySelector('.product-card__carousel-track');
        if (!t) return;
        var c = parseInt(t.dataset.count, 10);
        if (!isNaN(c)) carouselSet(t, c > 1 ? 1 : 0, true);
        return;
      }

      // Track finished a move onto a clone -> snap to the matching real slide so
      // the loop is seamless (no full-width scroll back).
      if (target.classList.contains('product-card__carousel-track') && event.propertyName === 'transform') {
        var count = parseInt(target.dataset.count, 10);
        var pos = parseInt(target.dataset.pos, 10);
        if (isNaN(count) || isNaN(pos)) return;
        if (pos === count + 1) {
          carouselSet(target, 1, true);
        } else if (pos === 0) {
          carouselSet(target, count, true);
        }
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-discontinued"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('discontinued-notice')) return;

    class DiscontinuedNotice extends HTMLElement {
      connectedCallback() {
        if (this.__init) return;
        this.__init = true;
        this.trigger = this.querySelector('[data-discontinued-scroll]');
        this.onClick = this.onClick.bind(this);
        if (this.trigger) this.trigger.addEventListener('click', this.onClick);
      }

      onClick() {
        var target = document.querySelector('.featured-products-section');
        if (!target) return;
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      }

      disconnectedCallback() {
        if (this.trigger) this.trigger.removeEventListener('click', this.onClick);
      }
    }

    customElements.define('discontinued-notice', DiscontinuedNotice);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity"] && !Shopify.designMode) return;
  try {
    // Delegated (not per-element) so steppers rendered after page load - e.g. cart
  // line items re-rendered via the Section Rendering API - work without re-binding.
  // Per-element binding only covered the markup present on load, so a re-rendered
  // stepper's buttons dispatched no change event and quantity-0 removal silently
  // failed for those lines.
  function esQuantitySync(root) {
    var input = root.querySelector('[data-quantity-input]');
    if (!input) return;
    var dec = root.querySelector('[data-quantity-decrease]');
    var inc = root.querySelector('[data-quantity-increase]');
    var min = input.min !== '' ? parseInt(input.min, 10) : null;
    var max = input.max !== '' ? parseInt(input.max, 10) : null;
    var val = parseInt(input.value, 10);
    if (isNaN(val)) val = min !== null ? min : 0;
    if (min !== null && val < min) val = min;
    if (max !== null && val > max) val = max;
    input.value = val;
    if (dec && min !== null) dec.disabled = val <= min;
    if (inc && max !== null) inc.disabled = val >= max;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quantity-decrease], [data-quantity-increase]');
    if (!btn || btn.disabled) return;
    var root = btn.closest('[data-quantity]');
    if (!root) return;
    var input = root.querySelector('[data-quantity-input]');
    if (!input || input.disabled) return;
    var delta = btn.hasAttribute('data-quantity-increase') ? 1 : -1;
    input.value = (parseInt(input.value, 10) || 0) + delta;
    esQuantitySync(root);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-quantity-input]');
    if (!input) return;
    var root = input.closest('[data-quantity]');
    if (root) esQuantitySync(root);
  });

  // Initial pass to clamp values and set button disabled states on load.
  document.querySelectorAll('[data-quantity]').forEach(esQuantitySync);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-input"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-search]').forEach(function (root) {
    var field = root.querySelector('[data-search-field]');
    var clear = root.querySelector('[data-search-clear]');
    if (!field || !clear) return;
    function sync() { clear.hidden = field.value.length === 0; }
    field.addEventListener('input', sync);
    clear.addEventListener('click', function () {
      field.value = '';
      sync();
      field.focus();
    });
    sync();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shopify-facets"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.esrShopifyFacets) return;
    window.esrShopifyFacets = true;

    /* Params carried over from the current URL when they are not already in the
       form: the search query and result type, and the grid display preferences.
       Deliberately NOT `loaded`/`page` - a changed filter set restarts paging. */
    var PRESERVE = ['q', 'type', 'view', 'cols', 'styled'];

    /* Monotonic request id: a slow response must not clobber a newer one. */
    var seq = 0;

    function getForm() {
      return document.querySelector('[data-shopify-filters]');
    }

    function currentGrid() {
      return document.querySelector('[data-collection-grid], [data-sf-grid]');
    }

    /* ---------- URL ---------- */

    function buildUrl(form) {
      var url = new URL(form.getAttribute('action') || window.location.pathname, window.location.origin);
      var data = new FormData(form);
      data.forEach(function (value, key) {
        if (value === '' || value == null) return;
        /* The price Min/Max text fields are display-only mirrors; the submitted
           price lives on the hidden gte/lte inputs. */
        if (key.indexOf('-display') !== -1) return;
        url.searchParams.append(key, value);
      });
      var current = new URL(window.location.href).searchParams;
      PRESERVE.forEach(function (key) {
        if (!url.searchParams.has(key) && current.has(key)) {
          url.searchParams.set(key, current.get(key));
        }
      });
      return url;
    }

    /* ---------- Swap ---------- */

    /* Groups the shopper has opened, so a re-render does not collapse the
       drawer under them (the accordion state lives in aria-expanded + an
       inline panel height). */
    function openGroups() {
      var open = {};
      document.querySelectorAll('[data-facet-group]').forEach(function (group) {
        var summary = group.querySelector('.collection-filters__group-summary');
        if (summary && summary.getAttribute('aria-expanded') === 'true') {
          open[group.getAttribute('data-facet-group')] = true;
        }
      });
      return open;
    }

    function restoreGroups(open) {
      Object.keys(open).forEach(function (name) {
        var group = document.querySelector('[data-facet-group="' + CSS.escape(name) + '"]');
        if (!group) return;
        var summary = group.querySelector('.collection-filters__group-summary');
        var panel = group.querySelector('.collection-filters__group-panel');
        if (summary) summary.setAttribute('aria-expanded', 'true');
        if (panel) panel.style.height = 'auto';
      });
    }

    /* Replaces every data-sf-swap node with its counterpart from the fetched
       section, paired by key in document order. */
    function swapAll(doc) {
      var pairs = {};
      document.querySelectorAll('[data-sf-swap]').forEach(function (node) {
        var key = node.getAttribute('data-sf-swap');
        pairs[key] = pairs[key] || { current: [], incoming: [] };
        pairs[key].current.push(node);
      });
      doc.querySelectorAll('[data-sf-swap]').forEach(function (node) {
        var key = node.getAttribute('data-sf-swap');
        pairs[key] = pairs[key] || { current: [], incoming: [] };
        pairs[key].incoming.push(node);
      });
      Object.keys(pairs).forEach(function (key) {
        pairs[key].current.forEach(function (node, i) {
          var replacement = pairs[key].incoming[i];
          if (replacement) node.replaceWith(document.importNode(replacement, true));
        });
      });
    }

    function afterSwap(doc) {
      /* The swapped price control is fresh markup; the theme's range module
         binds on load only, guards per root, and queries the document - so this
         is both necessary and safe on every swap. */
      if (window.esCollectionPriceRange) window.esCollectionPriceRange.init();

      /* The collection page's <collection-grid> element caches references and
         counts at connect; re-point them at the swapped nodes so Load more and
         the showing line keep working against the filtered set. */
      var host = document.querySelector('collection-grid');
      if (host) {
        host.grid = host.querySelector('[data-collection-grid]');
        var incomingHost = doc.querySelector('collection-grid');
        var total = incomingHost && incomingHost.getAttribute('data-total');
        if (total != null) {
          host.setAttribute('data-total', total);
          host.total = parseInt(total, 10) || 0;
        }
        host.loadedPages = 1;
        if (typeof host.applyStyled === 'function') host.applyStyled();
      }
    }

    function refresh(url, writeHistory) {
      var form = getForm();
      if (!form) {
        window.location.href = url.toString();
        return;
      }
      var grid = currentGrid();
      if (grid) grid.classList.add('is-loading');

      var fetchUrl = new URL(url.toString());
      fetchUrl.searchParams.set('section_id', form.getAttribute('data-section-id'));

      var id = ++seq;
      fetch(fetchUrl.toString())
        .then(function (response) { return response.text(); })
        .then(function (html) {
          if (id !== seq) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var open = openGroups();
          swapAll(doc);
          restoreGroups(open);
          afterSwap(doc);
          if (writeHistory !== false) {
            window.history.replaceState(window.history.state, '', url.toString());
          }
        })
        .catch(function () {
          /* Fall back to a full navigation rather than stranding the shopper
             on a grid stuck in its loading state. */
          if (id === seq) window.location.href = url.toString();
        });
    }

    /* ---------- Price ---------- */

    /* Mirrors the slider (already two-way-synced with the Min/Max fields by the
       theme's range module) into the hidden gte/lte inputs the form submits.
       Both thumbs at the extremes means no price filter, so the inputs empty
       and the params drop out of the serialised URL. */
    function syncPrice(root) {
      var min = root.querySelector('[data-range-min]');
      var max = root.querySelector('[data-range-max]');
      var gte = root.querySelector('[data-sf-price-gte]');
      var lte = root.querySelector('[data-sf-price-lte]');
      if (!min || !max || !gte || !lte) return;
      var floor = parseInt(root.getAttribute('data-floor'), 10) || 0;
      var ceiling = parseInt(root.getAttribute('data-ceiling'), 10) || 0;
      var lo = parseInt(min.value, 10);
      var hi = parseInt(max.value, 10);
      gte.value = lo > floor ? String(lo) : '';
      lte.value = hi < ceiling ? String(hi) : '';
    }

    /* ---------- Events ----------
       Delegated, so controls swapped on every refresh keep working. */

    document.addEventListener('change', function (e) {
      if (!e.target.closest) return;
      var form = e.target.closest('[data-shopify-filters]');
      if (!form) return;
      /* Sort still reloads the page via the drawer's own sort module -
         accepted fallback behaviour, matching the desktop sort control. */
      if (e.target.name === 'sort_by') return;

      var price = e.target.closest('[data-sf-price]');
      if (price) syncPrice(price);

      refresh(buildUrl(form));
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var link = e.target.closest('[data-sf-remove], [data-sf-clear]');
      if (!link) return;
      e.preventDefault();
      refresh(new URL(link.getAttribute('href'), window.location.origin));
    });

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.hasAttribute || !form.hasAttribute('data-shopify-filters')) return;
      e.preventDefault();
      refresh(buildUrl(form));
    });

    /* Back/forward: re-fetch for the restored URL so the grid, chips and
       facets match the history entry. */
    window.addEventListener('popstate', function () {
      if (!getForm()) return;
      refresh(new URL(window.location.href), false);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["suburb-suggestions"] && !Shopify.designMode) return;
  try {
    /* Postcode-to-suburb suggestions, shared by the PDP store-locator block and
     the store-locator page (#1190). See the LiquidDoc header in
     snippets/suburb-suggestions.liquid for why this is shared rather than
     copied. */
  (function () {
    if (window.__esSuburbSuggest) { return; }

    /* Mirror of normaliseSuburb() in workers/api/src/lib/transit.ts and
       scripts/build-transit-data.mjs. Used ONLY to decide whether Google has
       already offered a suburb, so "Mt Albert" from Google suppresses "Mount
       Albert" from us. If the worker's map gains an alias, add it here too or
       the same suburb can appear twice. */
    var ALIASES = {
      ST: 'SAINT',
      MT: 'MOUNT',
      NTH: 'NORTH',
      STH: 'SOUTH',
      E: 'EAST',
      W: 'WEST',
      N: 'NORTH',
      S: 'SOUTH'
    };

    function normalise(value) {
      return String(value || '')
        .toUpperCase()
        .replace(/[^A-Z0-9]+/g, ' ')
        .trim()
        .split(' ')
        .map(function (word) { return ALIASES[word] || word; })
        .join(' ');
    }

    /* Is the shopper searching by postcode? Digits only, three or four of them,
       returned zero-padded to the four digits the worker keys on - NZ shoppers
       type "600" as readily as "0600", and Excel strips the leading zero from
       the supply files too. Anything else (a suburb name, a street, a mix) is
       not a postcode query and leaves the existing behaviour alone. */
    function asPostcode(value) {
      var raw = String(value || '').replace(/\s+/g, '');
      if (!/^\d{3,4}$/.test(raw)) { return ''; }
      var padded = raw.length === 3 ? '0' + raw : raw;
      /* "0000" is not a real postcode in either market and only ever comes from
         a shopper typing zeros, so it is not worth a request. */
      return padded === '0000' ? '' : padded;
    }

    /* Suburbs for a postcode, from the worker. Resolves to [] on anything at
       all going wrong - a missing url, a network error, a non-OK response, an
       unknown postcode - because this only ever ADDS to Google's list, so the
       honest failure is to add nothing. Cached per url+country+postcode for the
       life of the page; the data is static. */
    var cache = {};
    function fetchSuburbs(transitUrl, country, padded) {
      if (!transitUrl || !padded) { return Promise.resolve([]); }
      var key = transitUrl + '|' + country + '|' + padded;
      if (cache[key]) { return cache[key]; }
      var url = transitUrl.replace(/\/$/, '') + '/suburbs?postcode=' +
        encodeURIComponent(padded) + '&country=' + encodeURIComponent(country);
      cache[key] = fetch(url)
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (body) {
          return body && body.found && body.suburbs ? body.suburbs : [];
        })
        .catch(function () { return []; });
      return cache[key];
    }

    /* The suburbs to APPEND, i.e. those Google has not already offered.
       `googleNames` is whatever each surface can read off its own predictions -
       the main text, which for a postcode query is the postcode itself and for
       a suburb is the suburb name. Order is the worker's (alphabetical). */
    function extras(googleNames, suburbs) {
      var seen = {};
      (googleNames || []).forEach(function (name) {
        var k = normalise(name);
        if (k) { seen[k] = true; }
      });
      var out = [];
      (suburbs || []).forEach(function (name) {
        var k = normalise(name);
        if (!k || seen[k]) { return; }
        seen[k] = true;
        out.push(name);
      });
      return out;
    }

    window.__esSuburbSuggest = {
      normalise: normalise,
      asPostcode: asPostcode,
      fetchSuburbs: fetchSuburbs,
      extras: extras
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["text-icon"] && !Shopify.designMode) return;
  try {
    (function () {
    function update(root) {
      var row = root.querySelector('.text-icon__row--m-carousel');
      var bar = root.querySelector('.text-icon__progress');
      var fill = root.querySelector('.text-icon__progress-fill');
      if (!row || !bar || !fill) return;

      var max = row.scrollWidth - row.clientWidth;
      if (max <= 1) {
        bar.hidden = true;
        return;
      }
      bar.hidden = false;

      var progress = row.scrollLeft / max;
      if (progress < 0) progress = 0;
      if (progress > 1) progress = 1;

      fill.style.width = (progress * 100) + '%';
    }

    function init(root) {
      if (root.dataset.tiInit === '1') return;
      var row = root.querySelector('.text-icon__row--m-carousel');
      if (!row) return;
      root.dataset.tiInit = '1';
      var run = function () { update(root); };
      row.addEventListener('scroll', run, { passive: true });
      window.addEventListener('resize', run);
      run();
    }

    function initAll() {
      var roots = document.querySelectorAll('[data-text-icon-carousel]');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["textarea"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-character-count]').forEach(function (field) {
    var wrap = field.closest('.field');
    var counter = wrap ? wrap.querySelector('[data-character-count-current]') : null;
    if (!counter) return;
    function update() { counter.textContent = field.value.length; }
    field.addEventListener('input', update);
    update();
  });

  document.querySelectorAll('[data-autogrow]').forEach(function (field) {
    var oneLine = 0;
    function measureBaseline() {
      /* The 1-line scrollHeight (incl. a textarea's ~4px intrinsic slack) */
      var v = field.value;
      field.value = '';
      field.style.height = 'auto';
      oneLine = field.scrollHeight;
      field.value = v;
    }
    function grow() {
      field.style.height = 'auto';
      var sh = field.scrollHeight;
      /* Single line: let min-height settle it at the input's 30px. Grown lines
         lose the 1-line slack, so add 3px back for the matching bottom gap. */
      field.style.height = (sh > oneLine + 1 ? sh + 3 : sh) + 'px';
    }
    measureBaseline();
    grow();
    field.addEventListener('input', grow);
    /* Re-measure once the web font has loaded - the fallback font's taller
       line would otherwise bake in a wrong baseline/height on first paint */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { measureBaseline(); grow(); });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist-notification"] && !Shopify.designMode) return;
  try {
    class WishlistNotification extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('[data-wishlist-notification-panel]');
      if (!this.panel) return;

      this.DISPLAY_MS = 5000;
      this.TRANSITION_MS = 200;

      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onPointerEnter = this.onPointerEnter.bind(this);
      this.onPointerLeave = this.onPointerLeave.bind(this);

      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('keydown', this.onKeydown);
      this.panel.addEventListener('pointerenter', this.onPointerEnter);
      this.panel.addEventListener('pointerleave', this.onPointerLeave);
      this.panel.addEventListener('focusin', this.onPointerEnter);
      this.panel.addEventListener('focusout', this.onPointerLeave);

      // theWishlist.io only builds `.toast-wishlist` after a successful save,
      // so its insertion is the add-to-wishlist signal (see the snippet doc).
      this.observer = new MutationObserver((mutations) => {
        for (let i = 0; i < mutations.length; i++) {
          const added = mutations[i].addedNodes;
          for (let j = 0; j < added.length; j++) {
            const node = added[j];
            if (node.nodeType !== 1) continue;
            if (node.classList.contains('toast-wishlist') || node.querySelector('.toast-wishlist')) {
              this.show();
              return;
            }
          }
        }
      });
      this.observer.observe(document.body, { childList: true, subtree: true });
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('keydown', this.onKeydown);
      if (this.observer) this.observer.disconnect();
      clearTimeout(this.dismissTimer);
      clearTimeout(this.hideTimer);
    }

    get open() {
      return this.hasAttribute('open');
    }

    show() {
      clearTimeout(this.hideTimer);
      this.panel.hidden = false;
      // Let the panel lay out before the opacity/transform transition starts.
      requestAnimationFrame(() => this.setAttribute('open', ''));
      this.scheduleDismiss();
    }

    hide() {
      if (!this.open) return;
      clearTimeout(this.dismissTimer);
      this.removeAttribute('open');
      this.hideTimer = setTimeout(() => {
        this.panel.hidden = true;
      }, this.TRANSITION_MS);
    }

    scheduleDismiss() {
      clearTimeout(this.dismissTimer);
      this.dismissTimer = setTimeout(() => this.hide(), this.DISPLAY_MS);
    }

    // Keep the tooltip up while the customer is reading it / tabbing the CTA.
    onPointerEnter() {
      clearTimeout(this.dismissTimer);
    }

    onPointerLeave() {
      if (this.open) this.scheduleDismiss();
    }

    onDocumentClick(event) {
      if (!this.open) return;
      if (this.contains(event.target)) return;
      this.hide();
    }

    onKeydown(event) {
      if (event.key === 'Escape' && this.open) this.hide();
    }
  }

  if (!customElements.get('wishlist-notification')) {
    customElements.define('wishlist-notification', WishlistNotification);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zendesk-widget"] && !Shopify.designMode) return;
  try {
    /* Open the widget from anywhere in the theme: any control carrying
     data-zendesk-open. Delegated on document, so it also covers markup that is
     injected or revealed after load - the PDP drawer tabs, for one.

     typeof guard rather than a bare "if (zE)": when the embed has not loaded, zE
     is an UNDECLARED identifier and the bare check throws a ReferenceError that
     would kill the handler silently. Messaging first (newer edition), Classic as
     the fallback - the account can be on either. preventDefault runs before the
     guard so a link never jumps to its href when the widget is missing. */
  (function () {
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest && event.target.closest('[data-zendesk-open]');
      if (!trigger) return;
      event.preventDefault();
      if (typeof zE !== 'function') return;
      /* A trigger can sit inside a modal - the PDP drawer tabs are a showModal()
         <dialog>, so they live in the TOP LAYER and paint over the widget
         whatever its z-index. Nothing can out-stack that, so close the dialog and
         let the chat come up on the page behind it. Closed only once the widget
         is known to be there, so a missing embed can't shut the panel for
         nothing, and via native .close() so each dialog's own close handler still
         restores scroll and focus. */
      var modal = trigger.closest('dialog[open]');
      if (modal && typeof modal.close === 'function') modal.close();
      try {
        zE('messenger', 'open');
      } catch (messagingErr) {
        try {
          zE('webWidget', 'open');
        } catch (classicErr) {
          /* Neither API target valid - widget misconfigured. No-op. */
        }
      }
    });
  })();

  /* Skin the Zendesk launcher bubble.

     The launcher is an iframe, but Zendesk builds its document in-page so it is
     SAME-ORIGIN and reachable - we inject one stylesheet into it rather than
     trying (and failing) to reach the button from the parent document.

     A stylesheet, not inline styles: the button is React-rendered and re-renders
     on hover/open, which would wipe inline styles. Zendesk's own colour rule
     (a styled-components class) carries no !important, so an !important rule
     here beats it regardless of specificity, and survives every re-render.

     Colours are read from the theme's CSS custom properties at runtime - the
     iframe is a separate document, so var() would not resolve inside it. */
  (function () {
    if (!document.getElementById('ze-snippet')) return;

    var SIZE = 46;
    var root = getComputedStyle(document.documentElement);
    var bg = (root.getPropertyValue('--color-warm-grey') || '').trim() || '#70675b';
    var fg = (root.getPropertyValue('--color-sand') || '').trim() || '#ffffff';

    var css =
      'html,body{background:transparent!important;}' +
      'body>div,body>div>div{width:' + SIZE + 'px!important;height:' + SIZE + 'px!important;' +
      'background:transparent!important;}' +
      'button{width:' + SIZE + 'px!important;height:' + SIZE + 'px!important;' +
      'min-width:0!important;min-height:0!important;' +
      'background-color:' + bg + '!important;border-color:' + bg + '!important;' +
      'border-radius:50%!important;color:' + fg + '!important;}' +
      'button svg{fill:currentColor!important;}';

    function skin() {
      var frame = document.getElementById('launcher');
      if (!frame) return false;
      var doc = frame.contentDocument;
      /* No head yet = the frame exists but Zendesk has not written into it. */
      if (!doc || !doc.head) return false;
      if (doc.getElementById('es-zd-launcher')) return true;
      var style = doc.createElement('style');
      style.id = 'es-zd-launcher';
      style.textContent = css;
      doc.head.appendChild(style);
      return true;
    }

    /* A heartbeat rather than a MutationObserver, deliberately.

       Zendesk mounts the launcher asynchronously, then REWRITES the iframe's
       document once the widget is ready - which silently discards a stylesheet
       injected into the placeholder. That rewrite happens inside the frame, so
       it is not a mutation of this document and an observer on body never sees
       it (tried; the bubble stayed black). The frame is also torn down and
       rebuilt as the messenger opens and closes.

       So: re-check once a second and re-inject if the stylesheet has gone. Each
       tick is two getElementById calls and an early return, which is cheaper
       than observing a subtree that mutates on every carousel tick. */
    skin();
    setInterval(skin, 1000);
  })();
  } catch(e) { console.error(e); }
})();

})();
